export const m = {
    about: '关于我们',
    Cooperationsupport: '合作支持',
    Partners: '合作夥伴',
    CompanyOverview: '公司概况',
    Legaldocument: '法律文件',
    Instruments: '交易產品',
    Commodities: '商品',
    Forex: '商品',
    Index: '指數',
    Options: '数字币',
    Platform: '交易平台',
    LoginTrade: '登錄交易',
    Platformintroduced: '平台介紹',
    DownloadCenter: '下載中心',
    Support: '培訓支持',
    News: '新聞資訊',
    Companynotice: '公司公告',
    IndustryNews: '行業新聞',
    EconomicCalendar: '財經日曆',
    FinancialNews: '財經快訊',
    Login: '登錄',
    Register: '註冊',
    Retrading: '一鍵交易全球',
    Singledd: '一個賬戶可以跨市場跨品種交易',
    Fastedd: '快速、簡潔的交易平台',
    transparentsd: '安全、公平、透明的交易環境',
    Integratingntsd: '金融與科技的融合',
    Regulatoryd: '持有多個國家的金融監管牌照',
    Starttrading: '開始交易',
    Openanaccount: '開設賬戶',
    Latestnews: '最新消息',
    Announcement: '公告',
    Various: '多個交易品種，多個市場',
    ReadMore: '了解更多',
    platformsw: '快速、穩定的交易平台',
    lcgGsw: 'AEGIS普通投資者的首選',
    lSimplecgGsw: '簡單、快捷、易用的平台',
    lSimplecgGsw2: '所有品種觸手可及',
    lapplicationecgGsw: 'AEGIS是一款基於網絡的應用程序，適合PC端或移動端的網頁登錄交易',
    ClientDownloads: '客戶端下載',
    Cdesignedds: 'AEGIS適合所有投資者',
    offerwe: '我們提供可在PC或移動端下載安裝的交易平台',
    through: '無論您身在何地',
    through2: '都可以通過安裝下載交易平台進行交易',
    DownloadApps: '手機端下載',
    time: '時間',
    Currency: "幣種",
    Important: "重要性",
    Activity: "活动",
    This: "今值",
    Predictive: "预测值",
    Before: "前值",
    withtrading: "攜手PLCG開始交易",
    applications: "選擇一個賬戶並提交您的申請",
    Funding: "入金",
    Fastsg: "通過借記卡或銀行卡轉賬快速安全地註資",
    Trade: "交易",
    Accessse: "訪問 商品、外匯、指數、期權等交易品種和交易方式",
    Tools: '工具',
    PrivacyPoilcy: "隱私條款",
    Disclaimer: "免責聲明",
    RiskWarning: "風險提示",
    UserAgreement: "用戶協議",
    ContactUs: '聯繫我們',
    investment: '您的投資價值可能上漲，也可能下跌。在保證金交易中，損失有可能超過保證金甚至是大部分本金。高槓桿意味著高風險，您應仔細考慮您的風險承受能力和對槓桿交易的理解程度。',
    transactionsw: '您必須認識到，風險不僅包含交易風險，還包括一些不可抗力因素所造成的風險，比如：網絡中斷，政治動亂、黑客攻擊等。',
    Parklifesdee: 'HK Bridge Point Technology Limited,Ltd擁有本網站的所有權和使用權，是全美期貨協會（NFA）會員，編號 0525014，受美國金融業監管局（FINRA）監管。獲得美國財政部數字貨幣交易許可，許可證號31000154458901，查詢鏈接 https://www.fincen.gov/msb-state-selector。',
    accessibledee: '本網站可在全球範圍內訪問，網站上所有的信息僅供參考，並不構成指引性建議，對於任何人依據本網站或網站的信息採取的作為或不作為所導致的後果，我們不承擔任何責任。',
    acoverageledee: '涵蓋黃金、白銀、原油、銅等主要活躍品種',
    Relatively: '相對較低的保證金',
    instrumentsely: '商品具有較高的流動性和波動率',
    professionalumentsely: '提供專家觀點和在線教育服務',
    dollaref: '涵蓋主要美元貨幣對以及多數非美貨幣對',
    largest: '全球最大的交易市場，每日交易量超過5萬億美金',
    Effective: '有效的對沖匯率波動和地緣政治風險',
    intradays: '日內豐富的交易機會',
    countriesw: '涵蓋主要國家、地區的股票指數',
    Indexcontracts: '指數合約可以有效的對沖股票交易風險',
    Inrepresentscts: '股票指數代表了相應交易所的主要股票水平',
    leveraging: '較少的資金撬動較大的交易規模',
    leforeigng: '涵蓋 BTC、ETH、LTC 等主流數位貨幣資產',
    risksng: '適合操作激進、經驗豐富的當日交易者之理想產品',
    purchsases: '供給量有限，伴隨需求增長，將推升數位貨幣資產價格上漲',
    Effectiver: '數位貨幣會隨市場情緒產生價格反應',
    Become: '成為世界頂尖交易平台的頂級經濟商',
    BecExploreome: '一起開拓世界',
    unlock: '成為PLCG經紀商，解鎖更多交易機會',
    unlChooseock: '選擇合作夥伴方案',
    partnership: 'PLCG根據您的需求提供多種合作方案',
    Broker: '經紀商',
    Brorebateker: '定制的返佣方案和靈活結算方式',
    Receiveateker: '外匯主要貨幣對：交易每百萬美金，佣金高達50美金',
    etfs: '大宗商品、指數合約、ETF、期權：多種交易品種，多種交易模式，滿足客戶的所有需求',
    Dealers: '交易商',
    Deaschemeslers: '根據您的需求提供返佣方案',
    conditions: '市場頂級條件和獨有宣傳資料',
    businesss: '多語言專業支持，為您擴展業務提供支持',
    accuratedf: 'PLCG代理後台為代理提供準確客戶信息，表現報告以及佣金詳情',
    informaqtions: '如需获取关于合作伙伴类型与返佣方案的更多信息，请点击下载',
    table: '申请表',
    and: '和',
    Brokeragreement: '經紀商協議',
    required: '并将其与所需文件一起邮寄或电子邮件发送给我们，电子邮箱：support@plcgx.com',
    reqWhyuired: '為何選擇PLCG？',
    transactions: '通過一家安全的以客戶為中心的供應商進行外匯交易',
    AboutPlcg: '關於PLCG',
    constructionwe: '我們致力於金融科技和交易生態的構建，為用戶提供豐富多彩的全球化交易體驗',
    consaccount: '一個賬戶，一個世界',
    Whatwedo: '我們的服務',
    build: '我們搭建數字平台以促進多資產市場准入，並為各種規模的客戶提供專業級工具、行業領先的價格和世界一流的服務',
    lnvestments: '投資和交易',
    foreignq: '通過一個賬戶，交易商品、外匯、指數、期權等合約產品，捕捉各個市場和品種的投資機會',
    Partnerships: '合作夥伴關係',
    bankingps: '通過開放式銀行解決方案，我們為 120 多家銀行和經紀商以及 300 多家金融中介機構提供支持，為他們提供多資產執行、主經紀商服務和交易技術',
    Licensedfg: '持牌、安全、穩定',
    ssociat: '擁有全美期貨協會（NFA）牌照，席位號為0525014（了解我們的持牌情況）',
    ssocchoosingiat: '當您選擇我們，您是選擇在一個受嚴格監管的平台上進行交易，以確保您交易的公正性。',
    Financiaecurity: '資金安全保障',
    securityurity: '資金安全對於交易者至關重要，確保投資者資金得到監管國家全方位嚴格監管。',
    sPowerfulurity: '強大的交易平台',
    accountrity: '一個賬戶交易多個市場品種，不論您在何地，我們交易平台都保持強大的穩定性。',
    Integrated: '強大的交易平台',
    Richproduct: '豐富的產品',
    Richpmarketsroduct: '通過一個賬戶交易多個市場和品種，我們從各大交易所獲取深度流動性的優勢',
    Stableplatform: '穩定的平台',
    Stexecuteatform: '快速執行交易指令，並不斷優化執行體驗，降低拒單率',
    Safetyguarantee: '安全的保障',
    fundsrantee: '客戶資金受嚴格監管，網站和交易平台具備強大防攻擊能力',
    Tradecommodities: '商品交易',
    Tradepreciouss: '可交易貴金屬、原油、銅等大宗商品',
    environment: '公正的交易環境',
    envConnectironment: '實時對接各大交易所數據，為客戶提供更具競爭力的價格優勢',
    Transility: '交易靈活性',
    Trleveragelity: '我們的產品系列讓您可以做多或做空，進行槓桿交易和對沖交易或對單個商品形成長遠判斷',
    Stablatform: '穩定的交易平台',
    mobilelatform: '通過手機、平板電腦、筆記本電腦或多屏桌面設置，您可以快速而有效地訪問市場',
    expertse: '提供5X24小時的專家服務',
    professionaltse: '您可在任何市場開放時間獲得專業支持，包括技術援助、市場分析以及聯繫您的個人銷售交易員',
    Competitivealtse: '極具競爭力的商品合約定價',
    InstrumentName: '合約名稱',
    ContractName: '合約規格',
    ounces: '盎司',
    barrels: '桶',
    pounds: '磅',
    Spread: '价差',
    Initialmargin: '即市保證金',
    Limitrgin: '單筆交易手數（手）',
    Positionn: '單邊持倉限制（手）',
    Strongq: '強大穩定的交易平台',
    derivatives: '衍生品交易首選平台',
    dWebvatives: '網頁端和下載端無縫對接',
    Multseiple: '多種工具和功能',
    indicatorsle: '各類分析指標助力您的交易',
    varietyle: '豐富的交易品種',
    foreignw: '使用同一個賬戶交易商品、外匯、指數、數字幣合約等產品',
    Moreinformation: '常見問題解答',
    eventsion: 'Q1. 商品領域應該關注哪些數據或新聞事件？',
    mainlyion: '商品主要關注歐美國家的政治經濟動態，關注的主要數據有：美國非農數據、EIA、歐佩克會議等',
    deliveryion: 'Q2. 你們是否實物交割？',
    contractsw: '我們不提供實物交付。期貨合約或期權合約將在交割期或到期日自動平倉。',
    informatitsw: 'Q3. 哪裡可以了解到實時的信息？',
    providedwq: '在我們新聞資訊裡可以查看到財經日曆和快訊，財經日曆和快訊為第三方提供，並不代表我們觀點或構成建議。',
    advicefe: 'Q4. 是否提供操作建議？',
    reprweesent: '我們不提供具體的操作建議，我們的專家發表的觀點或知識僅代表其個人或團隊，不構成交易依據。',
    Tradeorex: '外匯交易',
    currencyrex: '可交易全部美元貨幣對和非美貨幣對',
    Competitiveex: '極具競爭力的外匯合約定價',
    eventser: 'Q1. 外匯領域重點關注哪些事件？',
    dollareventser: '美元貨幣對主要關注美國的政治經濟政策，主要關注美聯儲的利率政策；非美貨幣對主要關注相關國家的利率政策和政治經濟變動。',
    indexesntser: '可交易歐洲、美國、亞洲國家或地區股票指數,',
    Asianntser: '主要包含標普500，納指、恆指、德指，富時A50等',
    Competitives: '極具競爭力的指數合約定價',
    shouldves: 'Q1. 交易指數應該注意哪些？',
    whethers: '指數代表了相對應國家的股票市場水平，主要關注相關國家的股市是牛市還是熊市或者說經濟是整體擴張上行的還是萎縮下滑的。',
    whetactivehers: 'AEGIS 是我們屢獲殊榮的交易平台，無論您是長期投資者還是全球市場上的活躍交易者，該平台都能讓您主宰自己的交易。',
    accessrs: '借助 AEGIS，您可以訪問所有可交易的金融工具和多種風險管理工具，並能獲取相應功能以在任意 PC、平板電腦或智能手機上迅速直觀地執行交易。',
    featuressrs: '主要特點',
    Mobility: '移動性',
    seamlesslyty: '在不同設備之間無縫移動，隨時隨地管控您的投資。在智能手機上開始，然後在平板電腦上繼續，最後在台式機上完成。設置和偏好將隨您轉移，您始終可以接著進行設定。',
    Keepdate: '掌握最新信息',
    economicte: '掌握獲取新聞推送、市場數據、經濟信息發布和實時圖表。標註圖表、使用技術分析工具以及監管您需要獲取的信息，從而確保高效交易最新信息',
    Intuitivete: '直觀交易',
    fastivete: '界面快捷、可靠且直觀。不會陷入交易運作方式的泥沼中。從圖表或專屬交易模塊進行交易。作出交易決策之後，可迅速執行交易而無需思考執行方式。',
    specifications: '平台特色和規格',
    Standions: '支持',
    Sservicesions: 'PLCG提供5*24小時的在線或電話支持服務。可隨時從平台上訪問支持服務台。',
    Oneesions: '一個賬戶',
    yourions: '通過 AEGIS 訪問您的賬戶，你可在PC和移動端無縫連接。',
    Information: '信息',
    pushtion: '從推送通知到新聞頻道，只需一個平台，您就可以進入全球金融市場。',
    puCrossshtion: '跨資產類別交易',
    includingion: '交易PLCG的所有資產，包括大宗商品、外匯、指數、數字貨幣。',
    Reliability: '可靠性',
    reliablfe: 'AEGIS 穩定可靠，能讓您隨時隨地進行交易。',
    Availability: '可用性',
    iOSty: '支持所有iOS設備',
    iOSdesktopty: '在台式機上訪問瀏覽器',
    Androids: '支持所有安卓設備',
    mobileids: '在移動設備上訪問瀏覽器',
    chooseeids: '為何選擇我們的交易app ？',
    major: '專為所有主流手機和平板電腦設計',
    updatedsd: '定期更新，盡可能為您提供最佳交易體驗',
    Completelyd: '完全免費下載',
    encryptiond: '採用安全的256位SSL加密，讓您放心交易',
    exclusiveb: '獲取有關外匯、股票和指數等市場的獨家數據和分析',
    analysise: '無需登錄即可查看實時價格的獨家數據和分析',
    terminal: '隨時隨地 多平台終端交易',
    tefunctionrminal: '覆蓋iOS、Android、Windows、Mac多個平台，支持全業務功能',
    thousandsminal: '上萬市場，盡在指尖',
    tallowssminal: '我們的移動交易應用程序可讓您交易豐富的金融市場，例如：',
    largestal: '參與全球最大的大宗商品交易市場，品種涵蓋黃金、白銀、原油等。',
    lforeignstal: '低點差交易多種外匯貨幣對，包括歐元/美元、英鎊/美元、歐元/英鎊等主流貨幣對',
    Nasdaq: '交易豐富環球股指，更可24小時交易恆生指數、納斯達克指數、標普500指數等',
    Namethodsdaq: '鎖定風險的交易方式，有效對沖相關標的其他交易方式的風險',
    tradingcfd: '何為CFD交易',
    risksgcfd: 'CFD交易有何風險',
    transactionss: 'CFD差價合約可用於哪些交易？',
    suitablede: 'CFD交易是否適合我',
    suitradede: '關於交易',
    onlineradede: '關於在線交易',
    CFDede: '什麼是差價合約交易？',
    speculating: '差價合約(CFD)交易是通過買賣差價合約，對金融市場的走勢進行預測，但並不實際買入或賣出任何標的資產的交易。',
    financialing: '差價合約(CFD)是同意就某資產自合約建倉直至平倉時的價值差進行交易的協議，是一種金融衍生品交易類型。',
    Latesting: "PLCG最新财经资讯",
    interpretationing: "实时更新，第一手资讯，第一秒解读",
    inttradingg: "什麽是價差合約交易",
    risksg: "價差合約有哪些風險",
    transactionss: "價差合約用於哪些交易?",
    suitableed: "差價合約交易適合我嗎?",
    contractsd: "差價交易合約（CFD）是一種在金融市場上進行投機的方式，不需要買賣任何基礎資產。 找出了解CFD交易所需的一切，從它的內容以及它如何工作到做空交易，槓桿和對沖。?",
    definedsd: "差價合約交易被定義為“差價合約的買賣”，“差價合約”的意思是“差價合約”。 差價合約是一種衍生產品，因為它們使您無需持有基礎資產的所有權就可以在股票，外匯，指數和商品等金融市場上進行投機。",
    dwhenefinedsd: "相反，當您交易差價合約時，您同意交換資產價格從合同開立到結束的價差。 差價合約交易的主要好處之一是，您可以推測任一方向的價格變動，並根據預測的正確程度來確定損益。",
    Shortd: "短期和長期差價合約交易說明",
    Senablesrtd: "差價合約交易使您能夠推測任一方向的價格走勢。 因此，儘管您可以模仿傳統的交易，即隨著市場價格的上漲獲利，但您也可以開設差價合約頭寸，該差價合約的交易將隨著基礎市場價格的下跌而獲利。 這被稱為賣出或“做空”，而不是買入或“做多”。",
    thinkblesrtd: "例如，如果您認為蘋果股票的價格將下跌，則可以出售該公司的股票差價合約。 您仍然可以交換開倉和平倉之間的價格差，但是如果股價下跌，則將獲利，如果股價上漲，則將獲利。",
    profits: "無論是多頭還是空頭，平倉後都會實現盈虧。",
    Learnts: "了解如何交易差價合約",
    LeLeveragearnts: "差價合約交易槓桿解釋",
    whichrnts: "差價合約交易是槓桿交易，這意味著您無需承擔全部費用即可獲得大量頭寸。 假設您想開設一個相當於500股蘋果股票的頭寸。 對於標準交易，這意味著要先支付全部股票費用。 另一方面，有了差異合同，您可能只需要承擔5％的費用。 了解有關差價合約和股票交易之間差異的更多信息。",
    enablesnts: "儘管槓桿使您可以進一步分散資本，但是請務必記住，您的盈虧仍將根據頭寸的全部規模進行計算。 在我們的示例中，這就是從您開始交易到結束交易時500股蘋果股票的價格差。 這意味著與您的支出相比，損益都可以被極大地放大，並且損失可能超過存款。 因此，重要的是要注意槓桿比率，並確保您在自己的能力範圍內進行交易。",
    explainede: "保證金解釋",
    sometimesk: "槓桿交易有時被稱為“保證金交易”，因為開設和維持頭寸所需的資金（“保證金”）僅佔其總規模的一小部分。",
    stypesometimesk: "交易差價合約時，有兩種保證金類型。 開倉需要保證金，而如果您的交易幾乎蒙受了虧損，而保證金和您賬戶中的任何額外資金將無法彌補，則可能需要維持保證金。 如果發生這種情況，您可能會收到提供商的追加保證金通知，要求您補充帳戶中的資金。 如果您沒有增加足夠的資金，該頭寸可能會被平倉，並且所產生的任何損失都將被兌現。",
    explainedq: "對沖差價合約的解釋",
    expusedlainedq: "差價合約也可以用來對沖現有投資組合中的損失。",
    exampledq: "例如，如果您認為投資組合中的某些ABC Limited股票可能由於令人失望的收益報告而遭受短期價值下跌的衝擊，則可以通過差價合約交易在市場上做空來抵消部分潛在損失 。 如果您確實決定以這種方式對沖風險，則您的投資組合中ABC Limited股票價值的任何下跌都將被您的差價合約差價合約交易的收益所抵消。",
    erisksxam: "差價合約有哪些風險？",
    marketsam: "了解金融市場交易涉及的風險，並了解如何使用我們廣泛的工具和資源來控制風險。",
    financialam: "差價合約與任何金融產品一樣具有風險–如果市場變化對您沒有幫助，您將蒙受損失。 但是，差價合約是槓桿產品，因此可能涉及更高的風險。",
    leverageialam: "什麼是槓桿？",
    allowsam: "利用槓桿，您可以用相對較少的資本投資就可以在金融市場上獲得更大的投資頭寸，換句話說，槓桿可以增加損益的範圍。",
    allhigherowsam: "槓桿交易的風險更高嗎？",
    capital: "儘管開立頭寸所需的資金數額較小，但您的收入或損失是根據頭寸的全部價值計算的。",
    capThereforeital: "因此，您的收入或損失金額可能相對高於您的初始投資金額。",
    controlledtal: "風險極限可以控制嗎？",
    managetal: "是的，我們提供了一系列工具來幫助您管理未結頭寸和控制風險限額。風險極限可以控制嗎？",
    Developk: "制定並嚴格遵守交易計劃",
    Dachievee: "交易計劃可以幫助您清楚地定義和實現總體金融交易目標。",
    expertiseee: "逐步培養技能和專業知識",
    leverageeee: "如果您剛開始使用槓桿產品，則可以嘗試一下以了解槓桿的工作原理，並加深對槓桿的了解。",
    Understande: "了解您感興趣的交易市場",
    factorsvf: "確保您了解影響不同市場的因素，以便根據最相關的信息制定交易策略。",
    Observesvf: "觀察您的空缺職位",
    positionsf: "從理論上講，您可以持續觀察您的未平倉合約並響應市場變化； 但是，這通常很難實現。",
    tabletsf: "我們的免費應用程序鏈接到我們的平台，使您可以使用手機或平板電腦查看交易。 您還可以通過設置價格警報來通知您達到指定價格的時間。",
    marketf: "使用止損和限制價格以避免市場干擾",
    sudden: "如果您無法及時應對市場的突然變化，則可能會蒙受損失。 如果市場出現“故障”，那麼在沒有交易的情況下它將跳漲跌落。 差距的原因可能是：市場",
    sabnormaludden: "收盤後，隔夜交易價格發生變化； 或在市場交易日發生異常事件。",
    protectn: "當市場突然變化時，我們的風險管理工具可以為您提供保護，而當市場變化對您有利時，您可以鎖定利潤。",
    protlimitectn: "這些包括止損，止損，尾隨止損和限價單。",
    learningbg: "保持學習",
    understanding: "通過深入了解交易市場並探索新的交易策略來提高成功率。",
    transactionsrf: "差價合約差價合約可以用於什麼交易？",
    multiplensrf: "差價合約可以在一個平台上交易多個市場。 以下是有關差價合約交易所涉及市場的詳細信息，包括指數，股票，外匯等。",
    reflectsrf: "指數是一個數字，它反映特定交易所上一組資產的價格表現。 由於股票價格指數不交易有形資產，因此交易指數的唯一方法是通過反映其價格的產品（例如指數差價合約）。",
    rwhichsrf: "指數差價合約是一種交易形式，其中一定數量的現金根據標的股票價格指數進行交換並以當地貨幣購買。 例如，每張香港恆生50指數（HK50）合約的恆生指數定價為每點50港元。",
    worldwide: "我們的指數差價合約可以在全球範圍內交易30多種指數，並且無論交易所的正常交易時間如何，您都可以每天24小時操作16個指數交易。",
    wLearnorwide: "了解有關指數差價合約交易的更多信息>>",
    wLeaexchange: "外匯兌換",
    frequentlyange: "如何交易外汇？ 外汇交易是指通过赎回不同货币来获利的目的。 由于其高波动性和24小时交易，外汇交易是世界上交易最频繁的金融市场。",
    transactionsf: "由於外匯交易的變化相對較小，因此大多數散戶投資者都使用槓桿交易。 外匯差價合約是交易外匯槓桿的有效方法。",
    actually: "您仍將以外匯貨幣對的形式進行外匯交易，對應於實際出售一種貨幣併購買另一種貨幣。 一份合約的價值取決於您交易的外匯貨幣對。 例如，GBP / EUR合約等於目標貨幣每點10歐元的變化，USD / JPY合約等於每點1000日元。",
    abouttually: "了解有关外汇差价合约交易的更多信息>>",
    ownershipk: "股票是特定公司的所有權單位。 股票的價值隨公司價值的增加或減少而變化。 您可以在股市上買賣股票，但是股票差價合約交易可以享受各種出色的測試。",
    generally: "與其他市場不同，股票差價合約是按佣金而不是點差收取的。 一張合約通常等於一張股票，因此交易股票差價合約與在國際股票市場上交易股票非常相似。",
    Stock: "股票",
    Sttraditionalock: "但是，由於差價合約是根據基礎資產價格變化進行交易的合約，因此股票差價合約比傳統股票交易更靈活。 例如，通過經紀人賣空股票通常是一個複雜的過程，但是對於差價合約，賣空和賣空是相同的。",
    Option: "選項",
    indicesk: "有什麼選擇？ 期權是在指定時期內以指定價格（稱為“行使價”）買賣市場的權利（並非義務）。 期權如何交易？ 我們的差價合約交易可以提供買賣指數和外彙的期權。",
    befospecificre: "買入或賣出期權使您有權在期權到期之前以特定價格購買差價合約差價合約。 我們還提供特殊形式的股票期權，而這些股票不必實際交付任何股票即可參與期權的價格變動。",
    aboutficre: "了解有關期權差價合約交易的更多信息>>",
    Commodity: "商品",
    Commrefersodity: "商品交易是指利用金屬和能源等商品的價格波動來獲取利潤。 由於商品的廣泛使用和資源稀缺，商品已成為全球投資者青睞的投資選擇。",
    commoditiesty: "在商品交易過程中，槓桿交易是大多數投資者的選擇，而商品差價合約交易是商品交易的有力選擇。",
    dependssty: "您仍將作為商品交易進行操作，單個合約的價值取決於您所交易的交易類型。 例如，一份黃金合約為100盎司，每次更改的價值為100美元。 WTI原油合約為1,000桶，每點價值10美元。",
    dcommodityty: "了解有關商品差價合約交易的更多信息",
    financialty: "如果您對金融市場運作有很好的了解並經常進行相關交易，則差價合約可能是您交易策略的重要組成部分。",
    newcomer: "我是交易新手",
    nthousandsomer: "差價合約交易使您無需花費大量初始資金即可進入數万個金融市場。",
    marketssomer: "股票交易佣金低，僅對大多數其他市場收費",
    positionmer: "完成頭寸交易，初始保證金很小",
    Makeionmer: "充分利用市場的興衰",
    indiceser: "可以開立外匯，指數，股票等頭寸",
    idownser: "請注意，差價合約可能會導致超出預付款的損失，可能並不適合所有交易者",
    iforexdownser: "我是外匯交易員",
    ibelieveser: "如果您是活躍的外匯交易員，我相信您已經從外匯交易中受益。 通過差價合約形式與我們交易，您將獲得更多利益。",
    serviceser: "直接外匯交易服務-直接進入交易所開始交易，掌握市場價差",
    seratiorviceser: "槓桿—我們的保證金比率低至0.5％",
    howiceser: "無論市場如何波動，保證止損都能為您的風險設定絕對限制",
    participateer: "可以參與超短期外匯交易的每日交易機會",
    foreignateer: "外匯交易沒有重新報價",
    conditionsteer: "通過我們的各種移動交易應用程序掌握最新的外匯市場狀況",
    portfoliocd: "在外匯投資組合之外探索貿易機會； 使用同一帳戶在16,000個市場中交易",
    porthatiocd: "請注意，差價合約是槓桿產品。 通過差價合約進行外匯交易可能導致損失超過預付保證金，並且可能並不適合所有交易者。",
    alreadyhatiocd: "如果您已經在交易股票指數，CFD允許您一天24小時交易大量現貨和期貨市場。",
    indextiocd: "我是指數交易員",
    ibenefocd: "差價合約有什麼好處？",
    istockocd: "股價漲跌都有獲利的機會",
    indicescd: "交易超過30種全球指數",
    Tradingcdd: "交易24小時",
    Trflexibilitydd: "更大的靈活性",
    expirationtydd: "現貨差價合約沒有到期日",
    anytimeydd: "使用該應用隨時隨地進行交易和跟踪",
    margiwnd: "低保證金率可讓您進行更多交易",
    supportd: "24小時客戶支持",
    lossesd: "請注意，差價合約被利用，可能導致損失超過預付款。",
    stocklossesd: "我是一名股票交易員",
    knowledges: "借助差價合約，您可以利用現有的知識和股市研究方法，並利用槓桿來增加投資資本和對沖實物投資組合。 當然，您需要牢記與內部槓桿相關的風險。",
    Australianges: "在同一帳戶中買賣澳大利亞和國際股票",
    increasees: "利用槓桿來增加投資資本",
    throughees: "通過非參與者直接配售通過市場價差進行交易",
    investmentes: "通過賣空保護您的實物投資組合，以避免受到不利的市場趨勢的影響",
    minimumentes: "開戶最低資金是多少？",
    mdeposittes: "要在PLCG開戶，最低入金為300美元。",
    kindes: "PLCG提供什麼樣的槓桿作用？",
    kfixedindes: "PLCG提供的槓桿是浮動的，保證金是固定的。",
    severales: "我可以在PLCG開設多個帳戶嗎？",
    additiones: "PLCG當前允許您開設真實賬戶，立即申請並立即開設。 此外，您可以開設多個模擬賬戶。",
    aclosingnes: "PLCG的開閉時間是幾點？",
    Americanes: "歐美DST",
    Saturdayes: "星期一上午7時至星期六凌晨4時",
    Closings: "關閉時間",
    Cleverydayosings: "每天凌晨5點至凌晨6點",
    Europeanbg: "歐美格林尼治標準時間",
    EuMondaybg: "從星期一早上7點到星期六早上5點",
    FromEuMondaybg: "每天早上6點至早上7點",
    provideaybg: "PLCG提供多少種差價合約？",
    includingb: "PLCG提供數十種CFDS進行交易，包括商品，外匯，指數等。有關詳細信息，請訪問PLCG網站的產品頁面。",
    indepositcludingb: "如何將資金存入我的帳戶？",
    methowdsb: "PLCG提供以下各種存款方法：",
    currhency: "數字貨幣場外交易",
    AliPayk: "通過支付寶付款",
    wpayment: "微信支付",
    Remittanceent: "中國銀聯匯款",
    depositsnt: "存款需要多長時間？",
    generallye: "通常是即時傳輸。",
    withdraw: "我如何提取資金？",
    withdrawal: "您只需要通過客戶帳戶中心的提款部分填寫提款請求，即可提款。",
    wopen: "如何開設真實的PLCG帳戶？",
    simplewopen: "開設真實的PLCG帳戶非常簡單。 打開“開設真實的PLCG帳戶”以填寫並提交您的開設帳戶申請。",
    submitpen: "開立真實的PLCG帳戶需要提交什麼文件？",
    Accordingen: "根據美國國家期貨協會（NFA）和美國金融業監管局（FINRA）的要求，PLCG必須在與客戶開設帳戶之前確認客戶的身份。",
    photogen: "您必須提交身份證和身份證照片以證明您的身份。",
    backgen: "身份證正面和反面",
    clearbackgen: "照片必須彩色打印且清晰。",
    numberckgen: "名稱，身份證號碼和有效期必須清晰可辨。",
    depositsen: "我可以從交易賬戶的存款中獲得利息嗎？",
    balanceen: "不會。PLCG不支付客戶資金餘額的利息。",
    fundsbalanceen: "我可以將自己的資金轉入朋友的銀行帳戶嗎？",
    paymentceen: "不允許第三方存款和付款。",
    sameen: "模擬賬戶與真實賬戶相同嗎？",
    squotationameen: "模擬賬戶和真實賬戶共享相同的報價來源，但是由於技術原因，它們無法享受相同的交易環境。 由於模擬賬戶的訂單未進入真實交易市場，因此無法與真實賬戶進行比較。 模擬賬戶旨在使交易者熟悉交易平台，因此不會提供真實的交易經驗。",
    bilateralen: "在CFDS交易中，您會看到雙向報價。 出價是指您可以出售的基礎貨幣的價格（同時購買非基礎貨幣）； Ask是指您可以購買的基礎貨幣的價格（同時出售非基礎貨幣）。 買入和賣出之間的差額是點差，而交易商則從買入和賣出之間的差額中獲利。",
    spreadalen: "點差是什麼意思？",
    sonlinepreadalen: "我該如何在線交易？",
    provideen: "任何人都可以在世界各地進行在線交易。 我們為您提供專業級的AEGIS平台，您可以在該平台上看到報價窗口，然後單擊以通過瀏覽器進行交易。同時，您還可以在手機，平板電腦和其他移動設備上進行交易。",
    pendingvf: "什麼是掛單？ 掛單有哪些類型？ 我可以在AEGIS上設置掛單嗎？",
    presetski: "掛單是指客戶預設了價格和交易方向（出價或要價），並且只有在達到預設價格時才會進行交易。",
    ordersbg: "掛單有四種類型：",
    equalordersbg: "買入限價多頭（低於當前價格）-當市場價格等於或低於預設價格時買入。",
    highersbg: "買入止損多頭（高於當前價格）-當市場價格等於或高於預設價格時買入。",
    Sellhighersbg: "限價賣空（高於當前價格）-當市場價格等於或高於預設價格時賣出。",
    Stopersbg: "止損賣空（低於當前價格）-當市場價格等於或低於預設價格時賣出。",
    executedde: "AEGIS允許設置掛單，這些掛單將存儲在服務器上，並在滿足條件時執行。",
    closingqw: "平倉保證金止損水平是多少？",
    namelyw: "PLCG平台的保證金止損水平為30％，即當您的保證金水平低於100％時，系統將開始強制清算。 我們的關閉規則是，當帳戶中資金的淨值小於保證金的100％時，系統將關閉持有人帳戶中的所有未平倉合約。",
    ntrendsamelyw: "此外，當市場處於發布重要數據或新聞（例如非農業數據）的快速趨勢時，這可能會導致您的損失超過保證金止損水平，甚至導致帳戶餘額為負數。",
    calculationlyw: "保證金水平的計算公式如下。",
    Usedlyw: "保證金水平=淨值/已用保證金x 100％=保證金水平％",
    Forexample: "例如",
    valueple: "在淨值為10,000美元的帳戶中，持有1個標準手的美元/日元，其保證金計算如下：",
    caoppositeusing: "如果此趨勢與您的持倉相反，導致您的淨值跌至3000美元，",
    continuesng: "當趨勢繼續運行，導致您的淨值下降到999美元時，您的帳戶頭寸將被強制關閉。 因為此時您的保證金水平是99.9％，低於指定的100％水平。",
    balancesuesng: "如何查看AEGIS上的餘額？",
    availablesng: "在AEGIS上，您可以查看帳戶中的實時餘額，淨值，保證金，可用保證金和保證金水平。 同時，您還可以查看實時損益。",
    periodng: "我的模擬賬戶有有效期嗎？",
    validityng: "AEGIS模擬賬戶的有效期為1個月。",
    limityng: "AEGIS模擬賬戶的有效期為1個月。",
    monthlyf: "PLCG對每月交易手數沒有下限。",
    holdingvf: "同時持有訂單是否有上限？",
    hoholding: "PLCG的最大持倉數量為10手，累計最大持倉數量為100手。",
    holosses: "我的損失會超過我的初始存款嗎？",
    liquidationw: "在AEGIS平台上，我們建立了強制清算系統，即，當您的保證金止損水平達到100％時，您的頭寸將自動關閉。 該過程由系統自動執行，只要您的保證金水平達到預設水平，系統就會以下一個價格水平關閉所有頭寸。",
    liimportant: "在某個特定時間或在發布重要數據（例如發布非農業數據）時，如果市場接近您的止損水平，而您的訂單在市場上交易，則市場可能會出現短暫的缺口。 缺口之後的價格，您的帳戶損失可能超過您的初始存款，這將導致負餘額。",
    orderstant: "我可以保留我的訂單多長時間？",
    interestsv: "您可以無限期保留訂單，但您必須有足夠的資金來維持權益。",
    computersv: "我可以在同一台計算機上登錄多個帳戶嗎？",
    Yescan: "是的你可以。",
    simultaneously: "我可以同時在不同的計算機上登錄同一帳戶嗎？",
    sidownloadly: "如何用手機下載PLCG平台？",
    sicodeadly: "掃描我們網站上的QR碼以下載我們的交易平台APP。",
    accounts: "1.對於已有賬戶的客戶，單擊“我的”登錄個人賬戶併申請開設真實賬戶或模擬賬戶；",
    Customersts: "2.沒有帳戶的客戶，單擊“我的” –“註冊帳戶”，您可以通過手機號碼或電子郵件方便快捷地註冊一個專用帳戶，並使用我們的服務。",
    widerersts: "PLCG對更廣泛點差的政策是什麼？",
    financialts: "價差擴大是金融市場的固有部分。 無論您是交易股票，期貨，商品還是外匯，您都將面臨更大的價差。 當您請求市場訂單時，您的訂單將被轉移到真實的金融市場。 輸入訂單時，市場價格可能已更改，因此您的訂單可能以新價格交易。 當市場劇烈波動時，點差可能會增加。 因此，當您在正常市場條件（例如發布非農業數據）之外進行交易時，請特別注意。",
    touchingcialts: "當市場劇烈波動時，一旦觸及止損價，系統可能會以市場價而不是您的止損價進行交易。 因此，我們不能保證您的訂單將以特殊趨勢的止損價進行交易。 有關詳細信息，請參閱風險聲明。",
    Positionlts: "鎖倉保證金？",
    Lockedlts: "鎖定頭寸訂單是指在同一賬戶中以相同數量持有相同商品的相反方向的多頭頭寸和空頭頭寸的交易合約。",
    occupancym: "確定鎖定後，客戶帳戶中的佔用裕度為0。",
    investmentv: "鎖倉交易會增加投資成本，在多頭和空頭合約上分別計算利息，直到相關合約平倉為止，我們公司不建議投資者採用這種策略。",
    wrongntv: "什麼是錯誤的價格？",
    wpricing: "當由於銀行間系統的報價錯誤（例如出現大利差或交易價格錯誤）而導致出現錯誤，遺漏，系統錯誤或顯示不正確時，錯誤的定價錯誤。 PLCG將對價格進行實時更正，由於系統錯誤，受錯誤價格影響的訂單將在最短時間內恢復，錯誤價格將不被視為交易訂單的依據。 （銀行會將錯誤的價格訂單的損益調整為零）。 由於錯誤導致的帳戶餘額，PLCG將不承擔任何責任。 以上內容並不包括所有情況，一旦報價執行錯誤發生，PLCG保留更正和調整有關報價和交易錯誤的糾紛的權利，並由PLCG自行決定。 客戶應同意賠償PLCG此類情況可能造成的損害或責任。",
    pendingdng: "掛單/限價/止損/止盈訂單的市場缺口安排？",
    profitng: "如果市場波動中沒有客戶設定的價格，則該公司現有未平倉合約的掛單/限價單和止損/止盈/止盈/止盈/止盈/止盈/止盈 點差，掛單將以缺口後的第一個價格出售； 如果當前價格和前一個價格之間的價格差小於平台產品價差，則將以客戶的默認價格執行掛單。",
    pServicerofitng: "客戶服務協議",
    PrivacyPolicy: "隱私政策",
    Disclaimer2v: "免責聲明",
    disclosurebv: "風險披露書",
    trustsurebv: "感謝您對百樂資本集團有限公司（以下簡稱“ PLCG”或“我們”）的信任和支持。 我們完全了解個人信息對您的重要性，並且我們致力於保護個人隱私。 根據在開展業務的國家/地區常見的法律，法規和隱私與數據保護原則，請採取適當的安全保護措施，以確保您的個人信息的安全。",
    affiliatesebv: "本隱私政策控制我們公司和關聯公司在使用我們的服務時如何收集，使用，披露和保護您提供給我們的個人信息，我們將嚴格按照本隱私政策的條款使用這些信息。",
    aproductsbv: "在使用我們的產品和服務之前，請務必仔細閱讀並理解本政策，並在確認您完全理解並同意後使用相關的產品和服務。 通過使用我們的產品或服務，您理解並同意本政策，並同意我們根據本政策合法使用和保護您的個人信息。",
    acollectbv: "1.我們收集什麼個人信息？",
    ausingtbv: "在使用我們的服務的過程中，我們會收集您因使用該服務而提供或使用的信息，以優化我們的服務並確保您的帳戶安全。 沒有這些個人信息，我們將無法為您提供這些信息。 服務。",
    registeringe: "（1）在註冊帳戶或申請開設基金帳戶的過程中提供的信息，例如：",
    gendernge: "①身份信息（例如姓名，性別，婚姻狀況，出生日期，身份證號碼/護照號碼，國籍，地址，聯繫信息，電子郵件，稅務管轄權等）和相應的證明材料；",
    gCareerernge: "②職業信息（如行業類別，職位，工資，就業單位，單位地址等）及相應的證明材料；",
    annualnge: "③資產信息（如收入來源，年淨收入淨額，流動資產淨額，銀行信用記錄，存款餘額和其他資產）以及相應的支持材料；",
    experiencenge: "④投資經驗（如投資年限，投資工具，交易歷史，投資偏好等）；",
    obtainedv: "（2）使用本公司提供的服務時獲得的信息，例如：",
    uniquedv: "設備信息（例如您的設備型號，操作系統，唯一的設備標識符，登錄IP地址，操作日誌等）；",
    duringv: "（3）在交易以及通過我們的系統進行存款和取款過程中獲得的信息。",
    dbankuringv: "①存取款信息（如銀行卡信息，金額信息等）",
    danalysisngv: "②交易信息（如交易信息，賬戶信息，賬戶利潤損失分析等）",
    additionalngv: "（4）我們還可能收集有關您的其他信息，以提供服務並改善我們的服務質量，包括您在聯繫我們的客戶服務團隊時提供的信息，以及您參與調查時發送給我們的調查表的答复。 信息，以及有關您已使用的移動應用程序（APP）的信息。",
    authorizengv: "當您使用我們的產品或服務時，您授權我們根據實際的業務和合作需求從我們的分支機構接收，匯總和分析我們的個人信息或交易信息，並確認它們的來源是合法的或您已被授權同意它們 。",
    authorizegv: "如果您拒絕提供以上信息或拒絕授權，則可能無法使用我們和關聯公司的產品或服務，或者可能無法顯示相關信息 。",
    rightgv: "如果您是歐盟用戶，則有權要求我們根據通用數據保護條例（GDPR）限制您的個人數據。 我們將根據您的要求進行評估。 如果符合GDPR法規，我們將根據法規中適用的特定條件處理您的數據，並在取消限制之前通知您。",
    ripersonal: "2.我們如何收集個人信息？",
    followingal: "在以下情況下，我們將收集您的個人信息：",
    processngal: "（1）在申請帳戶或使用PLCG網站/客戶端產品申請的過程中；",
    vfsngal: "（2）當您通過PLCG系統進行交易並使用PLCG公司提供的服務時：",
    openvfsngal: "①根據您的申請為自己開戶時；",
    managementvf: "②監控您的賬戶交易並進行風險管理",
    needvf: "③需要通過電匯方式提供聯繫方式時；",
    neservicesedvf: "④根據您的授權提供帳戶管理服務時；",
    ndepositedvf: "⑤當您的帳戶發起存款或提款時；",
    rghedvf: "⑥當我們執行客戶盡職調查程序時；",
    rwqghedvf: "⑦當我們執行反洗錢和反恐融資程序時；",
    mkrwqghedvf: "⑧當我們履行報告，披露或遵守規定的義務時。",
    mkrwfrqghedvf: "（3）通過網絡cookie等收集",
    fdhedvf: "（4）在其他情況下，您需要根據法律和法規要求收集您的個人信息。",
    yfdhedvf: "3.我們如何使用個人信息？",
    thyfdhedvf: "（1）我們將您的個人信息用於以下目的：",
    qewthyfdhedvf: "①用於改善我們提供給您的產品或服務，包括通過設備或網站提供的客戶支持和服務。 向您發送服務狀態，營銷活動和其他商業電子信息的通知。",
    ujhedvf: "②實施或協助其他機構進行信用審查；",
    bgujhedvf: "③開展相關的促銷活動。",
    bgujheddfdgvf: "④有關我們產品和服務使用情況的統計，以更好地改善我們的產品；",
    bthmkdfdgvf: "⑤存儲有關您的信息以進行我們的運營並遵守每個國家/地區的適用法律和法規。",
    qwekdfdgvf: "⑥防止或禁止違反法律法規的活動。",
    bgqwef: "⑦為了更好地為您服務，防止您使用我們的相關服務所帶來的風險或確定違反合同的責任，我們可能會通過第三方代理機構的查詢（例如，該人是否是政治敏感人士，是否 有犯罪記錄等）",
    pbgbgqwef: "⑧為了保護合理或必要地使用其他客戶，我們或我們的集團公司，其他用戶或僱員的人身和財產安全或合法權利。",
    requestwef: "如果您不希望我們將您的個人信息用於諸如推送之類的目的，則可以通過我們在推送消息中提供的提示或特定產品和/或服務中提供的指導，要求我們停止將您用於上述目的。 。 個人信息。",
    sfrequestwef: "根據適用法規，我們可能會根據業務需要在其他國家或地區的數據中心中存儲您的個人信息。 不同的司法管轄區可能會或可能不會提供與您的司法管轄區相似的數據保護法律。 。 但是，這不會改變我們根據本隱私政策保護您的個人信息的承諾。",
    fddgdwef: "在您與我們的關係終止後，我們將保留您的一些個人信息，這些信息將受國家法律和法規要求的約束。 如果您需要出於訴訟，調查和司法程序的目的保留您的個人信息，則保留時間將延長。",
    automatedwef: "對於歐盟用戶，我們不會按照GDPR條款對您的數據執行其他自動數據分析，例如用戶畫像。",
    ujjuef: "4.我們與誰共享您的信息？",
    tgreef: "除下述情況外，我們不會將您的個人信息透露給任何第三方。 如果需要公開披露，我們將告知您公開披露的目的，披露的信息類型以及可能涉及的敏感信息，並徵得您的明確同意：",
    rftwgreef: "①我們將在內部，本地和海外分支機構和關聯公司的許可使用範圍內處理您的個人信息。②我們可能會將您的個人信息披露給我們的第三方供應商（特快專遞，法律服務，會計服務，財務風險控制） ）.③為了判斷您的帳戶或交易是否安全或合規，我們將與在金融風險預防領域提供服務的公司，諮詢機構，監管機構等共享您的個人信息。④根據國家法律，我們可能會根據法律要求與警察，法院，監管機構或律師共享您的個人信息。⑤如果我們與第三方進行聯合促銷活動，我們可能會共享完成活動所需的個人信息，例如參加活動的用戶，獲獎名單，獲獎者的聯繫信息等，以便第三方可以在以下位置展示您的獎品（如果有） ⑥隨著我們業務的不斷發展，我們可能會進行合併，收購，資產轉移或類似交易，並且您的個人信息可能會作為此類交易的一部分而轉移。我們會在轉移前通知您。",
    sfwgrgeef: "5.主動共享信息的提示",
    busfwgrgeef: "（1）我們的產品和/或服務使您不僅可以與自己的社交網絡共享信息，還可以與產品和/或服務的其他用戶共享信息，例如，您在我們的產品和/或信息中上傳或服務中發布的信息（包括您公開的個人信息），您對他人上傳或發布的信息的回復以及與此類信息相關的位置數據和日誌信息。使用我們產品和/或服務的其他用戶也可能共享有關您的信息（包括位置數據和日誌信息）。只要您不刪除共享信息，該信息將保留在公共域中；即使您刪除共享信息，該信息也可能會被其他用戶或不受我們控制的非關聯第三方獨立地進行緩存，複製或存儲。用戶或此類第三方保留在公共領域中。因此，請仔細考慮是否通過我們的產品和/或服務上傳，發布和交換相關信息內容。在某些情況下，您可以與我們聯繫，要求從我們的產品和/或服務中刪除或修改您的信息。（2）某些個人信息由於其特殊性而可能被視為對個人敏感，例如您的財務狀況，收入來源，種族，宗教，個人健康和醫療信息。個人敏感信息比其他個人信息受到更嚴格的保護。（3）請注意，當您使用我們的產品和/或服務時提供，上傳或發布的內容和信息（例如，有關您照片的信息）可能會洩露您的個人敏感信息。 。您需要在使用我們的產品和/或服務時仔細考慮是否披露相關的個人敏感信息。（4）您同意我們可以出於本隱私政策中規定的目的和方式處理您的個人敏感信息。",
    thrgeef: "6.我們可能發送給您的消息和信息",
    yeggeef: "（1）郵件和信息通知",
    wdrgeef: "當您使用我們的產品和/或服務時，我們可能會使用您的信息向您的設備發送電子郵件，新聞或推送通知。 如果您不希望收到此信息，則可以按照我們的提示選擇退訂設備。",
    wereef: "（2）與產品和/或服務有關的公告",
    vgwereef: "必要時，我們可能會向您發布與產品和/或服務相關的通知（例如，由於系統維護而導致服務暫停）。 您可能無法取消與該產品和/或服務相關的且不是廣告的這些公告。",
    mireef: "7.您如何管理您的個人信息？",
    hyuuuf: "（1）訪問您的個人信息",
    rehyuuuf: "①除法律法規另有規定外，您有權訪問您的個人信息。②您可以通過登錄帳戶訪問和更新您的基本信息，登錄密碼，交易密碼，綁定手機和電子郵件地址。③您可以查看自己的個人信息。 我們網站和應用程序上的交易記錄。",
    tyrehyuuuf: "如果您無法訪問上述信息，則可以聯繫客戶服務，我們將回复您的訪問請求。如果您是歐盟用戶，您將有權要求我們檢索您的個人數據並將其傳輸給其他數據控制者 根據GDPR條款。",
    nhyruuf: "（2）修改您的個人信息",
    qweuf: "您可以通过“访问您的个人信息”中列出的方法更正或补充您的个人信息。",
    bgqweuf: "（3）刪除您的個人信息",
    bgqweufbg: "在以下情況下，您可以要求我們刪除您的個人信息：",
    mkiyufbg: "①我們對您的個人信息的處理是違法的。②我們未經您的明確同意收集和使用您的個人信息。③如果我們處理個人信息，則嚴重違反了您的協議條款。④如果您 如果是歐盟用戶，您有權要求我們根據GDPR條款刪除您的個人數據。",
    kuytyufbg: "（4）保護您的個人信息",
    gtetyufbg: "①您可以使用複雜的密碼而不向任何人透露您的登錄密碼或帳戶信息，從而保護您的個人信息。一旦您洩露了帳號和密碼，可能會對您造成法律後果。如果您發現您的帳號和密碼已經或將由於任何原因被洩露，請立即聯繫我們的客戶服務，以便我們採取適當的措施。但是，我們對任何這種情況概不負責，除非我們在合理的時間內採取行動。 ②當您登錄我們的網站或應用程序時，尤其是在公共設備上，應單擊註銷按鈕以在會話結束後立即註銷。 ③由於您未能保護您的個人信息的隱私而導致您訪問第三方的個人信息而造成的任何損失，我們概不負責。如果發現未經授權使用您的帳戶或其他安全漏洞，則必須立即通知我們。④您的協助將幫助我們更好地保護您的個人信息。",
    grtiuyufbg: "8. GDPR涵蓋的個人的更多權利或信息",
    mktiuyufbg: "果您的個人信息是在歐洲經濟區（“ EEA”）中設置的，則您將享受一系列受《通用數據保護條例》（“ GDPR”）保護的個人信息。 與個人信息有關的合法權利。 這些權利包括：",
    qwtmktiuyufbg: "（1）獲取有關您的個人信息處理的信息，並訪問您保留在我們公司中的個人信息。請注意，在某些情況下，我們有權拒絕訪問您的個人信息的副本。 （特別是受法律專業特權約束的信息）；（2）如果您的個人信息不正確或不完整，則可以要求我們進行更正，但是如果您需要提供有效的身份證明文件的副本以證明您身份的真實性信息，請一起提供；（3）在某些情況下，我們可能會要求我們刪除您的個人信息。請注意，在某些情況下（例如出於公共利益，公共衛生或科學研究和歷史研究目的），即使您要求我們刪除個人信息，我們也保留保留您的個人信息的權利；（4）在某些情況下，我們反對處理您的個人信息，並要求我們限制對您的個人信息的處理。同樣，在某些情況下，即使您反對或要求我們限制您對個人信息的處理，我們也有權拒絕您的請求；（5）撤回您的個人信息許可證。如果還有其他合法的法律原因，我們也有權未經您的許可繼續使用或處置它。",
    mkiiuyufbg: "根據GDPR條款，除了提供系統的個人數據保護方法外，我們還成立了數據保護官（DPO），全權負責您的數據保護工作。",
    ukiyufbg: "我們將評估收到的所有請求和投訴，並及時給您答复。 我們可能會要求您提供有效的身份證明文件的副本，以便我們能夠履行我們的安全義務並防止未經授權的數據洩露。 如果您訪問數據的請求顯然是沒有根據的或特殊的，或者您請求我們提供您的個人信息的其他副本，我們保留向您收取合理管理費的權利。",
    miukiyufbg: "對於受GDPR保護的個人信息，我們可能出於特定許可目的將您的個人信息轉移到EEA之外。 我們將確保任何此類國際轉移均受到GDPR或其他相關法律的適當保護。",
    ghyiyufbg: "9.信息安全",
    rewqfbg: "（1）我們致力於保護您的個人信息的安全，並防止信息的丟失，篡改，披露和不當使用。我們將採取各種安全措施在合理的安全級別上保護您的信息。（2）我們只會在本隱私政策規定的目的和法律法規允許的時間內保留您的個人信息。（3）為了保護您的信息安全，我們將採取合理和必要的措施在當前最新狀態下保護您的信息，並採取物理，技術和行政安全措施以減少丟失，濫用，未經授權的訪問和披露。更改的風險包括但不限於傳輸層數據加密，防火牆和加密存儲，物理訪問控制以及信息訪問授權控制。我們已經建立了一個安全程序，以保護您的信息免遭未經授權的訪問。例如：您與我們所有的網絡進行通信我們確保使用加密技術（SSL）進行加密保護。您的個人信息已加密，並使用高強度加密存儲在我們的服務器上。請理解，即使由於各種無法預測或無法預測的惡意方法，即使我們盡力採取上述措施，您的信息也可能被洩漏，破壞或丟失。（4）我們建立了專門的管理系統，流程和組織來保護您的信息。例如，我們嚴格限制了企業內部有權訪問信息的人員範圍。所有員工均簽署保密協議，並且獨立的安全組織定期進行審核。我們舉辦安全和隱私保護培訓課程，以提高員工對保護個人信息重要性的認識。（5）如果您是歐盟用戶，則除了提供系統的個人數據保護方法外，我們還將建立數據保護官（DPO）負責您的數據保護。（6）不幸的個人信息安全事件發生後，我們將根據法律法規的要求通知您：安全事件的基本情況和可能的影響，我們的處置措施已採取或將採取的措施，您可以自主預防和降低風險。建議，針對您的補救措施等與事件有關的情況我們將通過電子郵件，信件，電話，推送通知等方式通知您。當難以一一告知個人信息主題時，我們將在合理的時間內發出通知。有效的方式。同時，我們將根據監管機構的要求報告處理信息安全事件的方式。",
    mkrewqfbg: "10.我們如何使用Cookie？",
    qthwqfbg: "（1）Cookie是由Web服務器創建並存儲在用戶瀏覽器中的小型文本文件。 當用戶訪問Web服務器時，網站可以訪問Cookie信息。 Cookie除了用於識別用戶外，還可以用於存儲用戶信息和跟踪用戶訪問行為。（2）我們不收集和跟踪用戶的任何信息和行為，除非使用Cookie確認身份和 用戶的登錄狀態。（3）您可以根據自己的喜好管理和刪除cookie。 大多數瀏覽器都可以禁用或刪除系統中的cookie。 請務必注意，阻止Cookie可能會導致我們網站或系統上的某些功能無法使用或無法使用，從而可能影響您的體驗。",
    hytqfbg: "11.本隱私政策的更新",
    appropriatebg: "我們將適當地更新本指南的修訂，以反映我們處理您的個人信息或法律要求方面的變化。 如果我們對隱私政策進行了此類更改，我們將在官方網站上發布或以其他方式發布修訂後的政策。 更改自發佈到我們的網站時起生效。",
    mjuyiatebg: "我們建議您定期檢查此頁面，以獲取有關我們的隱私準則的最新信息。 您繼續使用我們的產品和網站上提供的服務將被視為受更新的隱私政策的約束。",
    bgtebg: "客戶服務協議",
    bGroupgtebg: "本協議（“協議”）約束客戶與HK Bridge Point Technology Limited，Ltd（“ PLCG”）之間的關係。 如果本協議與PLCG指定網站提供的內容有任何差異，則以本協議為準。 除非PLCG的經理以書面形式提出，否則不得更改或放棄本協議。 客戶不能更改或放棄本協議的任何部分。 客戶通過電子郵件或客戶登錄發出更改協議的通知後，確認PLCG可以更改本協議。 客戶在收到上述通知後對PLCG服務的使用被視為接受更改後的協議。 在使用PLCG的平台服務之前，客戶應仔細閱讀本協議，並在遵守所有條款後才能成為PLCG的客戶。 一旦使用了PLCG平台的功能，客戶便與PLCG形成協議關係，並受此協議約束。",
    mkigtebg: "1.風險提示",
    rtmkigtebg: "俗話說“股市有一定風險，投資明智”。投資證券可能會造成損失。任何證券的歷史數據都不能保證其未來的表現或回報。客戶的收益或損失無法得到保證，尤其是在市場低迷時期。國外市場的證券交易具有投機性，風險很高。此外，在正常交易時間之外還存在特殊的交易風險，包括低流量風險，高波動性風險，價格變動風險，市場無法連通以及新聞公告和較大的價差影響價格。客戶應充分了解和理解證券交易的相關風險。開戶前，應當從理性人的角度出發，根據其經濟實力，資金來源和風險承受能力，對要交易的投資對象和投資金額做出客觀判斷和酌情決定權。",
    hyigtebg: "PLCG及其關聯方的董事，僱員和代理商未完全以任何明確或暗示的方式確保與證券交易有關的信息的真實性，充分性，及時性，可靠性，完整性和有效性。 PLCG提供的所有信息，數據和資料僅供參考。 客戶應認識到並接受通過PLCG平台進行的交易不能沒有風險的事實。 交易產生的風險應由客戶承擔。 PLCG對客戶的投資風險和損失不承擔任何責任。",
    yhjubg: "2.不提供投資，稅收或交易建議",
    nhuyhjubg: "PLCG的代表或僱員無權提供投資，稅收或交易建議或徵求訂單。 PLCG的網站，產品，社區和交流團體的任何內容都不構成購買或出售證券或其他投資的建議或誘因。",
    yhkiubg: "開戶",
    mkikiubg: "客戶授權PLCG按照其說明開設並保留一個或多個帳戶。",
    tuimkikiubg: "（2）客戶資格",
    koiikiubg: "1.客戶應是符合有關交易法律和法規規定的合格投資者：",
    tykoiikiubg: "①自然人：客戶年齡在18歲以上，具有充分的公民權利和民事行為能力，並且具有足夠的知識和經驗來了解要交易的產品的性質和風險。②公司組織：客戶具有充分的資格 法人主體，具有充分的民事權利和民事責任能力。 計劃開設帳戶的人是公司組織的法定代表人，或具有該法人授予的合法有效授權。 計劃下達訂單的人具有法人所授予的法律和有效授權，並且具備足夠的知識和經驗，可以了解要交易產品的性質和風險。",
    hyuukiubg: "2.在PLCG平台服務的註冊，開戶和使用期間，客戶應提供其真實的資料和信息，並保證在此期間提交的所有資料和信息（包括但不限於電子郵件地址， 電話，地址，郵政編碼，ID信息和信用信息）是真實，準確，完整和最新的。 如果客戶的上述信息發生更改，客戶應及時以書面形式通知PLCG。 客戶授權PLCG進行任何調查，以驗證上述信息。",
    yuijkiubg: "3.如果不滿足上述條件，客戶應立即停止使用以下服務。",
    olpokiubg: "4.客戶的訂單/交易義務",
    okpolpokiubg: "客戶確認PLCG不知道使用客戶名/密碼輸入訂單的人是否是客戶。 除非PLCG收到通知並同意，否則客戶將不允許任何人訪問客戶的帳戶。 客戶應對用戶名/密碼的保密性和使用負責，並同意立即通過電話或電子郵件向PLCG報告此類用戶名/密碼的任何盜竊/丟失或對客戶帳戶的任何未經授權的訪問。 客戶應對使用其用戶名/密碼輸入的所有交易負責。",
    polipokiubg: "5.訂單的傳遞",
    bhuopkiubg: "除非另有指示，否則PLCG將選擇將客戶的訂單發送到的市場/經銷商。 對於在多個市場上交易的產品，PLCG或其合作夥伴可以提供“智能路由”，它通過計算機算法為每個訂單尋找最佳市場。 客戶端應選擇“智能路由”（如果可用）。 PLCG不能保證以最優惠的價格執行每一個訂單：PLCG可能無法訪問每個市場/交易商； 其他訂單可能會提前交易； 市場中心可能不遵守公佈的價格，或可能重新安排訂單以進行人工處理； 或市場規則，決策或系統故障可能會阻止/延遲執行客戶的訂單，或導致訂單無法獲得最佳價格。",
    myuuubg: "6.取消/修改訂單",
    eqmyuuubg: "客戶承認可能無法取消/修改訂單，並且儘管有取消/修改請求，客戶仍負責執行。",
    hukeqmyuuubg: "7，執行命令",
    poouuubg: "PLCG應以代理人的身份執行客戶的訂單，並可以進一步委託其他經紀人或子公司的代理人來執行客戶的訂單，在這種情況下，受僱的經紀人或子公司享有與PLCG相同的權利。 PLCG可以自行決定隨時拒絕客戶的任何訂單或終止客戶對PLCG服務的使用。 所有交易均應遵守相關市場或票據交換所的規則和政策以及適用的法律法規。 PLCG對任何交易所，市場，交易商，票據交換所或監管機構的任何行動或決定概不負責。",
    Confirmation: "確認書",
    qwConfirmation: "（1）客戶確認執行或取消的確認可能會延遲或錯誤（例如由於計算機系統問題），或者可能被交易所取消/調整。 如果與客戶訂單一致，則客戶受實際訂單執行的約束。 如果PLCG確認錯誤執行或取消，並且客戶延遲報告此錯誤，則PLCG保留從PLC帳戶中刪除交易或要求客戶接受交易的權利。",
    tyuation: "（2）如果發生以下情況，客戶同意立即通過電話或電子郵件通知PLCG：",
    kityuation: "①客戶未收到執行或取消的準確確認；②客戶收到與客戶訂單不同的確認；③客戶收到未下達訂單的確認； ④客戶收到的帳戶對帳單，確認書或其他信息反映了不正確的訂單，交易，餘額，頭寸，保證金狀態或交易歷史。 客戶承認PLCG可能會調整客戶帳戶以更正任何錯誤。 客戶同意立即將錯誤分配給客戶的任何資產退還給PLCG。",
    Margin: "保證金",
    rtyMargin: "1.保證金交易的風險：保證金交易的風險很高，可能導致資金損失大於客戶存入帳戶的資金。客戶表示他或她已經閱讀了PLCG或其合作夥伴單獨提供的“保證金交易風險披露”。2。連續保持充足保證金的要求：保證金交易受交易所，票據交換所和監管機構的初始保證金要求和維持保證金要求的約束，並且還要遵守PLCG可能更高的任何其他保證金要求（“保證金要求”）。 PLCG可以在任何時候根據PLCG的唯一要求修改任何或所有客戶的保證金要求。客戶應監控自己的賬戶，以確保賬戶中的資產始終能滿足保證金要求。如果帳戶的資產不足以滿足保證金要求，PLCG可能拒絕任何訂單，並且在確定保證金狀態時可能會延遲處理任何訂單。客戶應始終保持足夠的權益，恕不另行通知或要求，以持續滿足保證金要求。 PLCG網站上用於計算保證金要求的公式僅供參考，可能無法反映實際的保證金要求。客戶必須始終滿足PLCG.3計算的保證金要求。 PLCG不會發出保證金催繳：PLCG不必在PLCG行使其在本協議下的權利之前通知任何未滿足保證金要求的客戶。客戶承認PLCG通常不會發出追加保證金通知；通常，PLCG不會貸記客戶的帳戶來滿足日內或隔夜保證金不足；並且被授權清算賬戶頭寸以滿足保證金要求，恕不另行通知。 4.頭寸和抵消交易頭寸和抵消交易",
    qwrtyMargin: "①如果客戶帳戶在任何時候資產不足以滿足保證金要求或有赤字，PLCG有權自行決定（但無義務）清算客戶在任何PLCG帳戶中的全部或任何部分頭寸， 個人或聯營公司，在任何時間，以任何方式，通過任何市場或經銷商進行交易，而無需事先通知或要求客戶追加保證金。 客戶應承擔賠償責任，並應立即向PLCG支付因清算或清算後仍然存在的客戶賬戶缺陷。PLCG對客戶因清算而蒙受的任何損失不承擔任何責任（或PLCG系統延遲生效， 或不影響此類清算），即使客戶以較低的價格重新建立了頭寸。",
    kiuyMargin: "②在保證金不足的情況下，PLCG可能允許客戶預先請求清算的順序，但是此類請求對PLCG無效，PLCG保留自行決定要清算資產和清算順序/方式的權利。 PLCG可以通過任何市場或經銷商進行清算，PLCG或其關聯公司可以採取與法律和法規一致的交易的另一面。如果PLCG清算客戶帳戶中的任何/所有頭寸，則該清算應確定客戶的損益和對PLCG的剩餘債務（如有）。客戶應賠償PLCG對於與PLCG進行的任何此類交易有關的所有行動，疏忽，成本，費用（包括但不限於律師費）或責任，並使PLCG免受損害。如果PLCG執行客戶沒有足夠權益的訂單，PLCG有權在不另行通知的情況下清算交易，客戶應對由此造成的任何損失負責，並且無權獲得任何由此產生的利潤。",
    uiMargin: "③如果PLCG出於某種原因未清算保證金不足的頭寸並發出追加保證金通知，則客戶必須立即通過存入資金來滿足該追加要求。 客戶承認，即使發出呼叫，PLCG仍可以隨時清算頭寸。",
    tykrgin: "④客戶承認，PLCG也有權在不事先通知的情況下清算全部或部分客戶頭寸：",
    gthrgin: "（i）如果發生與客戶交易有關的任何爭議；（ii）根據下文第16條所述的任何“違約”；（iii）PLCG認為為保護PLCG而必須進行或建議進行清算時。",
    nygthrgin: "10，聯名賬戶",
    bgyhrgin: "每個聯名賬戶持有人均同意，每個聯名賬戶持有人均有權（不另行通知）：（i）買賣證券（包括保證金）；",
    mkityrgin: "①購買/出售證券（包括保證金）；②接收賬戶確認書和信件；③接收和處置貨幣，證券或其他資產； （iv）輸入，終止或同意修改本協議；④放棄本協議的任何部分；⑤與PLCG進行交易，就好像每個共同持有人是唯一持有人一樣。通知任何联名持有人即構成對所有聯名持有人的通知。每個聯名賬戶持有人應對所有賬戶事項共同承擔PLCG責任。 PLCG可遵循任何联名持有人的指示，並將任何賬戶財產分別交付給任何联名賬戶持有人。⑥任何联名持有人死亡後，尚存的持有人應通過電話或電子郵件通知PLCG，PLCG可以在通知之前或之後，提起訴訟，要求提供文件，保留資產和/或限制其認為適當的交易，以保護自己免受任何責任或損失。任何已故聯名賬戶持有人的財產均應承擔責任，並且每個遺屬對賬戶中的任何債務或損失或在賬戶清算時，均應對PLCG承擔連帶責任。除非客戶另有說明，否則PLCG可以假定帳戶持有人是具有倖存權的聯合承租人。任何联名持有人去世後，該帳戶應歸屬尚存的持有人，不得以任何方式免除已故聯名持有人的財產的責任。",
    miprgin: "11.PLCG帳戶的多幣種功能",
    jytgin: "（1）客戶在購買與基準貨幣不同幣種的產品時，可以使用客戶選擇的基準貨幣來交易以不同貨幣計價的產品，並創建了保證金貸款來為購買提供資金，並以資產作抵押 在客戶的帳戶中。 如果客戶保持以外幣計價的頭寸，PLCG將通過應用PLCG指定的匯率來計算保證金要求。 PLCG將應用“減記”（對外幣股權金額的百分比折扣），以反映基礎貨幣和外幣之間的匯率波動的可能性。 客戶必須始終密切監控保證金要求，尤其是對於以外幣計價的頭寸，因為貨幣波動和基礎頭寸的價值可能會導致保證金赤字。",
    poigin: "（2）客戶同意PLCG對客戶的義務應以下列方式表示：",
    mukpoigin: "①美元；②客戶存入資金或應客戶要求轉換資金的程度，以這種存款和兌換為限；③因交易而向客戶累計資金的貨幣 在指定的合約市場或註冊的衍生品交易執行機構上進行，但應計入這些費用。",
    mkpmukpoigin: "12.外匯兌換（簡稱“外匯兌換”）",
    puyykpoigin: "（1）外匯交易的高風險：外匯交易通常不受監管。 由於涉及槓桿（保證金），因此具有很高的風險，因此產生的財務損失可能會超過客戶存入帳戶的資金。 客戶確認PLCG提供的“外匯交易和多幣種賬戶風險披露聲明”。",
    lpoigin: "（2）對於外匯交易，PLCG通常作為代理人或無風險實體收取費用。 PLCG可以通過其分支機構或第三方進行外匯交易，上述分支機構或第三方可以從上述交易中獲利或承擔損失。 客戶同意PLCG可以將任何資金或資產轉移或轉移到客戶的受監管的期貨或證券賬戶中，從客戶的任何非受監管的外匯賬戶中轉移或轉移，以避免發生追加保證金通知，減少借方餘額或其他任何情況。 法律原因。",
    poolgin: "（3）淨結算：",
    muipoolgin: "①通知債務更新以進行淨額結算。客戶與PLCG之間的每筆外匯交易將立即以相同貨幣對客戶與PLCG之間的所有現有外匯交易進行淨結算，以形成交易。②支付淨結算。如果在任何一個交付日期，一種貨幣要有多個到期日，則各方應計算要交付的總金額，而僅計算差額。③終止淨額結算。例如客戶：（a）任何PLCG帳戶的保證金不足； （b）拖欠PLCG的任何義務，（c）破產或其他類似程序，（d）未能償還到期債務，PLCG有權但無義務終止客戶的外匯交易，清算全部或部分客戶客戶的抵押品，並使用所得款項來償還欠PLCG的任何債務。扣除淨額或任何“違約”之後，所有未完成的外匯交易將在觸發事件，請願或訴訟之前被視為已終止。⑤PLCG的權利附加於PLCG擁有的任何其他權利（無論是通過合同，法律還是其他方式）。",
    rgyoglgin: "（4）本合同中的任何內容均不得視為PLCG提供一般外匯交易或簽署任何特定外匯交易的承諾。 PLCG保留無限制地拒絕任何外匯交易訂單或拒絕以任何貨幣進行雙向市場報價的權利。",
    koplgin: "13，賣空",
    shortlgin: "客戶承認，根據保證金要求，賣空必須在保證金賬戶中進行； 在賣空之前，PLCG必須相信它可以藉入庫存用於交貨； 並且如果PLCG無法借入股票（或在召回通知後重新借入），PLCG可以代表客戶購買股票，而無需通知客戶，以補足空頭頭寸，並且客戶應對任何損失/費用承擔責任。",
    poiflgin: "14.PLCG的貸款/抵押客戶資產的權利",
    koigin: "PLCG和客戶可能會不時進行交易，其中一方將某些證券借給另一方。 每個此類交易在本文中均稱為“貸款”。 在相關監管要求允許的情況下，PLCG受客戶授權向其自身或其他客戶的證券或資產放貸，以作賣空或其他目的。",
    lpoikoigin: "15，擔保權益",
    kpioigin: "現特此將PLCG或代表PLCG持有的代表客戶帳戶的所有資產抵押給PLCG，並享有完善的第一優先權和擔保權益，以保證PLCG能夠確保履行此或任何其他對PLCG承擔的義務和負債 協議。",
    piiuigin: "16，默認事件",
    tgyhgin: "（1）“默認”自動發生，恕不另行通知：（i）客戶違反/否認與PLCG的任何協議； （ii）客戶應PLCG的全權酌情要求，未向PLCG提供令人滿意的保證以履行其義務； （iii）客戶根據/根據任何破產，破產或類似法律進行的訴訟； （iv）為客戶債權人的利益而轉讓； （v）為客戶或客戶財產任命接管人，受託人，清盤人或類似人員； （vi）客戶的陳述不真實或在作出陳述時具有誤導性，或以後變得不真實； （vii）客戶的法律無能； （viii）著手任何監管機構或組織暫停客戶的業務或許可； （ix）PLCG有理由相信上述任何事情都可能馬上發生。",
    plotgyhgin: "（2）客戶無條件同意，一旦發生違約，PLCG可以終止任何或全部PLCG對客戶的義務，PLCG有權自行決定，但無義務在不事先通知的情況下清算客戶的全部或部分頭寸 在任何時間，任何方式，通過任何市場或經銷商在任何PLCG帳戶中的個人或聯名賬戶。 客戶應償還與任何客戶違約或PLCG在違約時進行的任何交易相關的所有行動，疏忽，成本，費用（包括但不限於律師費）或責任，並使PLCG不受損害。",
    eyygin: "17，可疑行為",
    tgkeyygin: "如果PLCG自行決定認為客戶帳戶涉及任何欺詐，犯罪或違反法律或法規，或者被非法訪問，或以其他方式參與任何可疑活動（無論是受害者，犯罪者還是其他），則PLCG 可能會暫停或凍結該帳戶或該帳戶的任何特權，可能凍結或清算資金或資產，或可能將本協議中的任何補救措施用於“默認”。",
    pereyygin: "18，未以現金結算的商品期權和期貨",
    rewygin: "客戶確認：（A）不能行使商品期權，必須通過對沖將其關閉； （B）未通過現金結算實際交割的期貨合約（包括不在PLCG可交付貨幣清單中的貨幣），客戶無法進行或接受交割。 如果客戶未在PLCG或其合作夥伴網站上發布的最終期限之前抵消商品期權或實物交割期貨頭寸，則客戶授權PLCG轉讓或關閉或清算由期權或期貨合約引起的任何頭寸或商品，客戶 對所有損失/費用負責。",
    mpoewygin: "19，佣金和費用，利息費用和資金",
    pqwergin: "除非PLCG官員另行書面同意，否則佣金和費用均在PLCG網站上指定。 客戶承認PLCG從客戶帳戶中扣除佣金/費用，這將減少帳戶淨值。 如果佣金或其他費用導致保證金不足，頭寸將被清算。 更改佣金/費用將在以下任何一種情況下立即生效：在PLCG網站上發布或通過電子郵件或其他書面通知客戶。 PLCG應按照PLCG網站上的利率和條款向客戶支付貸方利息並從中收取借方利息。 在交易結算之前，不會支付客戶資金。 存入和提取資金的條款和條件（包括持有期限）在PLCG網站上指定。",
    bgtergin: "20.賬戶減去餘額",
    qvjtergin: "如果現金帳戶出現赤字，將適用保證金利率，直到還清餘額為止，PLCG有權（但無義務）將該帳戶視為保證金帳戶。 客戶同意為任何未支付的客戶赤字支付合理的託收費用，包括律師費和託收代理費。",
    pootergin: "21，國外市場風險，盤後交易風險",
    qwpootergin: "客戶確認在國外市場進行證券交易是投機性的，並且具有很高的風險。 此外，在正常交易時間之外還存在特殊的交易風險，包括低流量風險，高波動性風險，價格變動風險，市場無法連通以及新聞公告和較大的價差影響價格 。 客戶聲明其對上述風險有充分的了解，並具有承擔此類風險的能力。",
    oiootergin: "22，證券，權證及公司行為的知識",
    lpoiootergin: "客戶確認有責任了解其帳戶中任何證券的條款，包括即將採取的公司行動（例如，要約收購，重組，股票分割等）。 PLCG沒有義務將截止日期或所需採取的行動或會議日期通知客戶，沒有客戶通過電子郵件通過PLCG網站發送給PLCG的具體書面指示，PLCG也沒有義務採取任何行動。",
    pllpoiootergin: "23，行情，市場信息，研究和互聯網鏈接",
    nhuotergin: "通過PLCG（包括通過外部網站的鏈接）（“信息”）可訪問的報價，新聞，研究和信息可由獨立提供商準備。該信息是PLCG，提供者或其許可人的財產，並受法律保護。未經PLCG或提供者的書面同意，客戶同意不以任何方式複制，分發，出售或商業利用信息。 PLCG保留終止對信息的訪問的權利。這些信息均不構成PLCG的推薦或買賣建議。 PLCG和提供者均不能保證信息的準確性，及時性或完整性，客戶在做出投資決定之前應諮詢顧問。依賴報價，數據或其他信息的風險由客戶自行承擔。在任何情況下，plcg或提供者概不負責由於使用信息而造成的間接，偶然，特殊或間接損害。對於該信息，沒有任何明示或暗示的保證，包括適銷性保證，特定用途適用性保證或不侵權保證。",
    potergin: "24.使用PLCG軟件的許可",
    lpotergin: "PLCG授予客戶非排他性的，不可轉讓的許可，以僅按此處提供的方式使用PLCG軟件。 PLCG軟件和更新的所有權仍是PLCG的專有財產，包括所有專利，版權和商標。 客戶不得將PLCG軟件出售，交換或轉讓給他人。 客戶不得將PLCG軟件複製，修改，翻譯，反編譯，反向工程，分解或分解為易於閱讀的形式，也不得改編或改編PLCG軟件，也不得將其用於創建衍生作品，除非得到PLCG官員的書面授權。 PLCG有權對可能違反這些承諾的行為立即採取禁令救濟。.使用PLCG軟件的許可",
    mjhdgin: "25.免責聲明和違約賠償",
    thmjhdgin: "（1）豁免",
    qdrthmjhdgin: "①PLCG沒有義務調查已註冊手機號碼所有者身份的真實性，對於因在PLCG平台上註冊，盜用或濫用個人手機號碼的帳戶而造成的任何損失，PLCG不承擔任何責任。②在PLCG上註冊和開設帳戶的所有客戶應遵守相關法律法規和使用PLCG平台的規則，並且不得發布與政治相關的有害信息，色情內容，虛假廣告，血腥和暴力，侮辱性或誹謗性評論，披露個人隱私和違反法律法規的任何其他信息，也不得從事侵犯第三方知識產權和其他合法權益的活動。否則，客戶應承擔由此產生的所有損失，而PLCG對此不承擔任何責任。③在任何情況下，PLCG對任何懲罰性，間接，偶然，特殊或相關的損失或損害概不負責，包括但不限於間接的人身傷害，業務利潤損失，交易中斷，業務信息丟失或任何其他依賴權益的損失。④由於對證券或金融產品的投資有損失的風險，PLCG將不對損益和風險承擔責任。 ⑤PLCG及其關聯公司不能保證他們提供的諸如市場報價，圖表和評論之類的信息的絕對可靠性和準確性，或者由於市場的任何內容的不正確或缺失或客戶的主觀性而造成的損失⑥由於故障，折斷，延遲或其他因素而可能發生的交易指令的中斷，暫停，延遲或數據故障⑦由於忽略了客戶的交易帳戶和密碼，或假冒其身份，客戶的交易帳戶和密碼被假冒。⑧由於互聯網上存在惡意黑客攻擊的可能性，並且Web服務器可能存在故障和其他不可預測的因素，因此市場信息⑨客戶的NTE和軟件系統可能遭受非法攻擊或病毒感染，導致無法下達委託或委託失敗的訂單。⑩客戶的NTE和軟件系統與PLCG的在線交易不兼容系統，導致委託訂單失敗或委託失敗。在這種情況下，客戶可以撥打PLCG的電話報告這種情況並獲得技術支持，但不能獲得PLCG的經濟補償。of佣金失敗或佣金錯誤是由於客戶的不當操作造成的。from由於包括客戶帳戶和密碼在內的情況而造成的損失，個人信息或交易信息因其個人原因而被洩露或偽造。⑬客戶使用PLCG提供的服務進行任何非法活動或侵犯他人權益的行為，從而給客戶和第三者造成損失network由於網絡故障，在PLCG平台上運行時，客戶的NTE顯示其委託成功，而PLCG的交易服務器未收到客戶的委託指令，從而導致客戶無法買賣證券的風險；由於客戶的NTE顯示其委託沒有成功，客戶發送了另一筆委託單，這導致PLCG的交易服務器接收到客戶的兩條委託指令，並將這些指令傳送給證券公司進行交易，因此存在重複交易的風險。risk因法律和政策的重大變更或PLCG不可預測和無法控制的因素而導致的緊急情況。⑯PLCG平台的功能由於戰爭，通訊故障，自然災害，罷工和政府部門採取的不可抗力等不可抗力而失效， ⑰PLCG的指定網站和產品將發布或傳輸其合作公司提供的新聞和信息等內容，並註明信息提供者。 PLCG不對其合作公司提供的內容進行實質性審查或修改，也不保證其真實性，這應由客戶判斷，PLCG不對此負責。",
    loudgin: "（2）違約金",
    poloudgin: "客戶確認，在使用PLCG系統期間可能會出現延遲或中斷，包括由PLCG故意保護其係統引起的延遲或中斷。 在任何情況下，無論採取什麼行動，無論客戶遭受什麼損失，PLCG的義務都可能超出事故發生前六（6）個月內客戶向PLCG支付的最大每月佣金總額。",
    gypoloudgin: "26.隱私保護",
    mloudgin: "（1）根據法律監督的要求，PLCG將收集以下客戶的非公開信息：身份信息和就業信息，賬戶餘額和賬戶交易歷史，信用歷史和投資經驗。（2）PLCG將收集在以下情況下客戶的個人信息：開立賬戶或進行交易，在進行電匯，從客戶賬戶中存入或提取資金時提供客戶的聯繫信息。（3）PLCG將根據客戶的個人信息和資料開展以下活動， （隱私）條款和其他適用法律：為客戶提供投資服務和產品，進行信用調查或協助其他主管機構進行信用調查的日常運作，確保客戶保持良好的信用，符合審查制度和相關法律的披露要求，法規和行政權力。（4）波斯最終信息保護措施：PLCG將採取符合法律要求的安全措施，包括但不限於計算機保護措施，文件加密和安全的辦公大樓，嚴格管理和保護客戶的個人信息，防止未經授權的訪問和使用以及保護客戶的個人信息。 （5）除非法律法規要求，否則PLCG不會將客戶的個人非公開信息透露給第三方。 PLCG僅在以下情況下才披露客戶的個人信息：有必要授權，完成，監控或執行客戶的要求或授權交易，維護和監控客戶的賬戶，向客戶提供賬戶確認，賬戶對賬單和記錄，保留正確的案例記錄，有必要履行我們的客戶協議和其他協議，有必要履行PLCG的責任或保護PLCG的權利和財產，司法機關，行政機關和其他主管監督機關根據法律程序執行法律或法律監督，這是根據相關法律，法規或規則披露客戶的個人信息所必需。",
    mloudginb: "27.客戶維護替代交易安排",
    temloudginb: "PLCG等基於計算機的系統固有地容易受到破壞，延遲或故障的影響。 在plcg系統不可用的情況下，客戶必須維護客戶的plcg帳戶之外的其他交易安排，以執行客戶的訂單。 通過簽署本協議，客戶表示客戶維持其他交易安排。",
    kodginb: "28.披露聲明",
    followingb: "PLCG在此向客戶聲明以下內容：A）PLCG將確保從收到之日起保護客戶的資產，直到：（a）證券的合法所有權已註冊到客戶的名稱中或以客戶的實益身份持有。有關發行人的證券登記冊；或（b）客戶明確指示PLCG將為轉存給執行對手方而參與首次公開募股的資金存入我們;（B）客戶應知道PLCG破產後，資產（包括可以被客戶確定地追溯）將被返還，轉移或分發給客戶或其代表，資產的可分配金額將根據客戶資產的比例進行分配;（C）資產歸還通知書確定的身份將在一般發行的報紙上公佈;（D）客戶應是其賬戶中資金的實益擁有人，並應確保資金的來源和使用是合法的，以及存入和存入的程序貨幣兌換符合客戶所在司法管轄區的相關法律和法規（包括但不限於新西蘭和中國）。因客戶資金的所有權和合法性引起的任何爭議或任何相關的處罰，應由客戶解決。如果由此給PLCG造成任何損失，客戶應全額賠償PLCG。",
    juujngb: "29.接受電子數據和通信協議",
    mkjuujngb: "PLCG向客戶提供電子交易確認，對帳單，稅收信息以及其他客戶記錄和電子形式的信件（“電子記錄和信函”）。 為了安全起見，電子記錄和通訊可能會發送到客戶的交易平台或客戶的電子郵件地址或在PLCG的網站上發布，並會通知您登錄並蒐索與客戶的上述信件。 簽署本協議，即表示客戶同意接收電子記錄和通訊。 除非客戶收回其協議，否則上述協議仍然適用，並且適用於每個納稅年度。 客戶可以隨時以書面形式將其召回協議告知PLCG。 如果客戶收回協議，PLCG應根據客戶要求通過電話或電子郵件提供紙質稅收文件。 但是，PLCG保留要求客戶關閉其帳戶的權利。",
    ukujngb: "對系統軟件和硬件的要求是通過PLCG的交易平台進行交易並通過交易平台接收電子記錄和通訊，這在PLCG的網站www.plcgx.com上進行了說明。 由於上述要求可能會發生變化，客戶必須定期訪問PLCG網站，以了解系統的當前要求。 要接收PLCG的電子郵件，客戶應保留有效的Internet電子郵件地址和電子郵件軟件，以閱讀，發送和接收電子郵件。 更改其電子郵件地址後，客戶必須立即通過更改PLCG網站上規定的客戶電子郵件地址的程序，將此類更改通知PLCG。",
    Miscellaneous: "雜",
    Miscgovernedus: "（1）本協議受澳大利亞法律管轄，與本法律條款相抵觸的條款將無效。在所有司法行為，仲裁或爭端的決議中，當事方放棄對任何損害賠償的權利。 （2）爭議解決：經雙方協商同意，客戶在PLCG平台上使用交易服務引起的爭議應通過優先協商解決。（3）客戶同意本條款以中文書寫並註明它了解本協議的條款。本協議包含雙方之間訂立的完整合同，雙方將不會從本協議中發表其他聲明或提供其他證券。本條款中任何條款的不可執行性均不會影響本條款中其他條款的效力。 PLCG未履行本協議的任何條款均不應視為對本協議條款的放棄。（4）客戶同意PLCG通過電話記錄其所有對話。客戶確認PLCG的隱私聲明，並同意PLCG根據PLCG的規則收集/使用客戶的信息。（5）未經PLCG事先書面同意，客戶不得轉讓本協議項下的任何權利或義務。向客戶發送通知後，PLCG可以將本協議轉讓給另一經紀人，貿易商或期貨經紀人。該協議應保證PLCG的繼承人或受讓人的利益。 PLCG可以隨時終止本協議或終止向客戶提供服務。客戶可以通過電子郵件通知PLCG通過PLCG網站關閉其帳戶，但是，只有在清除所有職位並滿足PLCG網站上規定的關閉帳戶的所有其他要求之後。（7）PLCG享有解釋和修改此權利的權利。協議。如果本條款中的任何條款由於任何原因完全或部分無效或無法執行，則本條款的其他條款仍然有效並具有約束力。（8）本《客戶服務協議》應以中英文訂立。中英文版本如有任何歧異，概以英文版本為準。",
    kivernedus: "我確認提交給PLCG的個人身份信息，財產狀況，投資經驗和手寫簽名信息是真實準確的。 我已經知道並同意授權PLCG使用上述材料開設個人證券帳戶，並在所有必要的情況下以及在製作所有必要的文件時使用該材料，我願意對其進行約束。",
    Disclaimerft: "免責聲明",
    mkiimerft: "1. PLCG沒有義務審查已註冊手機號碼所有者身份的真實性。 如果個人手機號碼被盜，欺詐或用作PLCG平台帳戶註冊，PLCG將不承擔任何責任。",
    kiomerft: "2.所有在PLCG上註冊並開設帳戶的客戶都必須遵守PLCG平台的相關法律，法規和使用規則，並且不得在PLCG平台上張貼任何政治上有害，淫穢的色情內容，虛假廣告，血腥暴力行為 （社區，交流小組等）。 侮辱，侮辱，個人隱私和其他非法和非法信息，不得從事侵犯第三方合法權益的活動，否則由此引起的一切損失應由客戶承擔，PLCG不承擔任何責任 。",
    yuimerft: "3.在任何情況下，PLCG均不對任何懲罰性，間接，偶然，特殊或後果性的損失或損害承擔責任，包括但不限於間接的人身損害，商業利潤損失，貿易中斷，業務信息丟失或任何其他損失。 信賴利益。",
    qwyuimerft: "4.投資證券或金融產品存在虧損的風險。 PLCG對投資利益損失和客戶風險不承擔任何責任。",
    yujmerft: "5. PLCG及其關聯公司不能保證所提供的信息價格，圖表，評論和其他信息絕對可靠和準確，並且對由於客戶造成的任何內容或主觀原因的不准確性或遺漏不承擔任何責任。",
    eryujmerft: "6.由於互聯網數據傳輸故障，終端，延遲等，可能導致交易指令的中斷，暫停，延遲，數據錯誤等。",
    mkuerft: "7.由於客戶的疏忽，交易帳號和密碼信息被洩露，或者其身份被偽造。",
    tymkuerft: "8.由於Internet上可能受到惡意攻擊的原因，網絡服務器可能有故障以及其他不可預測的因素，市場信息和其他產品信息可能有誤或延遲。",
    iiktymkuerft: "9，客戶網絡終端設備和軟件系統可能受到非法攻擊或病毒的攻擊，導致無法發出委託或委託失敗。",
    yhjmkuerft: "10.客戶網絡終端設備和軟件系統與PLCG提供的在線交易系統不兼容。 無法發出委託或委託失敗。 客戶可以撥打PLCG電話報告情況並獲得技術支持，但無法獲得PLCG的經濟補償。",
    yjkuerft: "11.因客戶操作不當或委託失敗而導致的故障。",
    uiift: "12.因客戶個人原因而偽造帳戶密碼，個人信息，交易數據披露或客戶身份而造成的損失。",
    qwuiift: "13.客戶使用PLCG提供的服務從事任何非法或侵犯他人權益的行為，從而給客戶和第三方造成損失。",
    ryuqwuiift: "14.由於網絡故障，當客戶通過PLCG平台進行操作時，客戶網絡終端設備顯示委託成功，PLCG交易服務器未收到委託指令，從而產生用戶無法購買的風險 並出售； 客戶網絡終端設備委託沒有顯示成功，因此客戶再次發出了委託命令，PLCG交易服務器收到了客戶的兩條委託指令，並將指令傳遞給證券公司進行交易，從而導致用戶 冒著重複交易的風險。",
    vuiiift: "15.由於PLCG的不可預測和不可控制的因素而導致的法律和政策方面的意外更改或意外事件。",
    veuiyift: "16.由於戰爭，通訊故障，自然災害，罷工和政府部門的行為等不可抗力，無法實現PLCG平台的功能，從而導致客戶經濟損失。",
    uioyift: "17.合作公司提供的新聞，信息和其他內容將在PLCG的官方網站和產品上發布和轉載。 在發布和重新打印時將指示內容提供者。 PLCG不對其提供的內容進行任何實質性審查或修改，也不保證內容的真實性。 請自行判斷，PLCG不承擔任何責任。",
    mkuioyift: "尊敬的商人：",
    lopmkuioyift: "為了充分理解交易風險，本風險披露是根據《 PLCGX操作管理辦法》的有關規定進行的。 如果您選擇參與交易所市場交易，則視為您已閱讀該風險的前述規定，並暴露了展覽書籍並自願承擔與交易有關的風險。",
    drfuioyift: "鑑於交易商對風險交易進行投資並可能導致交易商蒙受損失，請仔細考慮其案例是否適合此類交易，並確定自己的風險和損失，同時客觀，理性地了解交易風險包括： 但不限於：",
    drkuytt: "一，宏觀經濟風險：",
    qwudrkuytt: "由於該國宏觀經濟形勢的變化，可能會影響到交易工具價格上下波動的情況； 國際宏觀經濟形勢的變化將對市場產生影響，存在引起交易滋生價格上下波動的情況。",
    yuopytt: "二，政策法規與市場風險：",
    plopyuopytt: "做市交易作為一種創新的交易模式，其交易規則在實踐中需要不斷完善，國家法律，法規和政策的變化以及其他影響價格波動的因素，可能會影響交易工具的價格； 或因國家法律，法規和政策導致的市場變化而對交易市場的相關規則進行修訂，可能會影響交易實體的資格和交易規則的變化。 聯交所上述法律，法規，政策和法規的風險可能導致該交易市場中交易工具的價格異常波動。",
    mytyuopytt: "第三，交易風險。",
    thjoytt: "（1）交易者需要了解，做市交易具有投機性和風險性，可能導致損益。 如果開倉方向與市場波動相反，則會造成巨大損失。 根據損失的程度，交易商必須有條件隨時滿足補充資金的要求。 否則，該頭寸將被強制轉移，而經銷商必須承擔由此產生的全部損失。",
    typytt: "（2）在交易系統中，在線終端通過在線終端提交的市場價格是單一的，交易是不可撤銷的。 投資者必須承擔該方法可能帶來的風險。",
    poyhtt: "（3）交易市場，交易商及其職員不會為交易商提供利潤保證，也不會與交易商分擔收益或承擔風險。 交易者應意識到，做市交易的任何利潤保證，或承諾不會發生損失的承諾都是不可能的，也是沒有根據的。",
    qtbpoyhtt: "（4）交易者的交易文件必須基於他們自己的決定。 該市場，經銷商及其職員提供的有關市場分析的任何信息和信息僅供交易者參考，並不構成任何要約。 經銷商從生產線承擔由此產生的交易風險。",
    hjupoyhtt: "（5）在電子交易過程中，可能出現明顯的報價錯誤機會，此後市場可能會出現錯誤的價格，所產生的損益會糾正錯誤的價格，從而經銷商從生產線上承擔交易風險。",
    pooyhtt: "（6）如果您缺乏在線交易經驗，則可能導致不正確的交易或操作錯誤。",
    ptuiooyhtt: "四，技術風險：",
    uytiooyhtt: "交易的進行，信息的顯示和資金的支付是通過電子通信技術和計算機技術實現的，並通過互聯網進行傳輸，這些技術可能會受到網絡黑客和計算機病毒或通信的攻擊。 技術，計算機技術和相關軟件可能會存在缺陷。 互聯網傳輸失敗也可能導致您的交易指令無法及時傳輸。 這些風險可能會導致您的交易申報未能完成或不是所有交易，或者無法及時收到轉移資金。 ，交易延遲，暫停，甚至無法完成交易等。",
    tyuiyhtt: "五，不可抗力風險：",
    uiopiyhtt: "不可抗力因素，例如地震，颱風，火災，洪水，戰爭，瘟疫，社會動盪等，可能導致交易系統的缺陷； 該交易市場等中不可控制和不可預測的系統故障，設備故障，通信故障，電源故障也可能導致交易系統異常運行甚至被篡改； 銀行無法控制和不可預測的系統故障，設備故障，通信故障，電源故障等也可能導致資金轉帳系統異常運行甚至偽造。 這些風險可能會導致您的交易。 聲明無法完成或無法完成，或者轉移資金無法及時支付。",
    hyuyhtt: "六，賬戶密碼洩露風險：",
    qwehyuyhtt: "由於密碼洩漏，帳戶洩漏或交易者使用交易商的身份使用計算機，用戶可能無法正確發出聲明單，惡意的虛假聲明或報告失敗。 延誤，錯誤等",
    yuiyhtt: "七，操盤手的軟件和硬件系統風險：",
    thuitt: "交易者的計算機設備和軟件系統與所提供的在線交易系統不匹配，導致無法發布報告指令或報告失敗，延誤等。",
    kpothuitt: "八，其他風險：",
    yjipptt: "密碼丟失，操作不當，投資決策錯誤等可能導致交易者蒙受損失； 在線聲明，熱鍵不能在熱鍵操作完成後及時退出，以及他人惡意操作造成的損失； 在線交易不及時退出可能還會導致黑客入侵和損失。",
    werytptt: "以上所有風險均可能導致經銷商蒙受損失，損失全部由經銷商承擔。 當交易者參與市場交易時，任何其他由他人作出的盈利或不盈利的承諾都是沒有根據的。 類似的承諾不會減少損失的可能性。",
    tyuptt: "此風險披露無法揭示進行做市交易的所有風險。 因此，在您進入市場之前，應告知自己充分了解《 PLCGX運營管理辦法》的交易規則和規定以及本風險披露聲明以及所包含的其他風險以外的自身經濟承受能力，風險控制能力，身心承受能力 （僅自然人交易客戶）做出客觀判斷，進行市場交易以供仔細研究。 一旦選擇在這個市場上進行交易，就被視為已完全理解並接受了在該交易市場中進行交易的與交易相關的系統，規則，方法和風險。",
    endtyuptt: "鄭重承諾：我選中與當前頁面“風險披露”相對應的複選框，然後單擊“同意並繼續”按鈕以表示我已仔細閱讀上述風險聲明，完全理解並同意，並自願承擔由此產生的任何風險。 以及由此造成的所有可能損失。",
    endkiuy: "涵蓋BTC、LTC、EHT、XRP等主流加密貨幣品種",
    hottestiuy: "當今最熱的投資市場",
    uiystiuy: "相對較低的保證金",
    Richtiuy: "日內豐富的交易機會",
    mainstreamuy: "可交易BTC、LTC、ETH、XRP等主流加密貨幣",
    qeweg: "極富競爭力的數字幣差價合約定價",
    dataqeweg: "Q1.加密空間應關注哪些數據或新聞事件？",
    Tradingg: "交易加密貨幣合約專注於全球政治和經濟發展以及美元價格的變化。",
    Notice: '通知',
    CFDtrading: 'CFD差價合約交易',
    CFDtmajorng: '以相對較低的保證金和費用交易加密貨幣等主要活躍市場和品種',
    ICOransaction: 'ICO幣兌交易',
    Supportmajorng: '支持全球主流加密貨幣的幣兌交易',
    OTCansaction: 'OTC場外交易',
    otcajorng: '支持各國法幣與主流加密貨幣場外兌換',
    Blockchnsaction: 'Blockchain區塊鏈錢包',
    Blockchjorng: '運用區塊鏈去中心化技術，實現對資產的安全管理，便捷流通',
    yijygr: '一鍵交易全球，一個賬戶可以跨市場跨品種交易',
    yijygrsd: '快速、簡潔的交易平台，安全、公平、透明的交易環境',
    yijyssfgrsd: '金融與科技的融合，持有多個國家的金融監管牌照',

    srsrea: '快速反應，追求卓越',
    ssrsresa: 'Trade Globally with One Click.',
    aboutsas: '關於',
    aboutbpt: '關於AEGIS',
    adsboutbpt: '法律法規',
    adposfbpt: '劣勢',
    adposfsrrbpt: '在使用槓桿交易產品之前，您應該首先考慮您的風險偏好和投資策略。使用槓桿有利有弊，既能擴大利潤，也會加劇虧損。如果市場出現不利於您的巨幅波動，你的帳戶可能會出現穿倉。這裡需要強調的是您並不實際擁有差價合約下的標的產品。可以在我們網站找到關於CFD交易的收益和風險的詳解。',
    drrtpt: '市場',
    drrtptssd: '市場範圍',
    dseerrtptssd: '大宗商品',
    deerptssd: '數位貨幣',
    desffrssd: '靈活的合約規模',
    desseffrssd: '參與全球金融市場',
    desfttqd: 'CFDS使交易者能夠參與到原本很難進行投資的全球市場。CFD使得交易黃金、白銀、石油等商品以及全球指數變得更加便利，而不必交易期貨合約本身。',
    deaqnmsffrssd: 'CFD的合約規模通常小於標的投資產品的合約規模，這意味著您可以在不需要巨額保證金的情況下參與到標的投資產品的價格變動中去。靈活的合約規模能夠在滿足您風險管理標準的情況下設計出符合您的交易需求。',
    dssdeerptssd: '商務合作',
    rtrjkd: '協助',
    rtrjkdsf: '協助中心',
    rssstrjkdsf: '外匯交易的優勢',
    rssqqstrjkdsf: '差價合約的優勢',
    bhyydsf: '一鍵交易全球, ',
    qyydsf: '一個帳戶可以跨市場跨品種交易',
    qyyddesf: '點差表0.0點起',
    seqyyddesf: '沒有「隱藏費用」的原始點差意味著我們真的可以達到0.0點',
    qqyyddesf: '我們多樣化且專屬的流動性組合，讓點差全天候24小時、每週5天報價',
    qqbbbesf: '超快速訂單執行',
    qqwbbbesf: '平均執行速度低於40毫秒',
    swebesf: '低延遲光纖連接至流動性提供商（LP）',
    swqweebesf: '我們的頂級訂單撮合引擎每日處理超過10,000,000筆交易',
    swqereebesf: '機構級報價提供商',
    swawwqereebesf: '真實、充足且多元的銀行間流動性，來源高達50家不同的流動性供應商',
    sqqeereebesf: '不重新報價，有效減少滑點',
    sqqgtbesf: '每日處理超過150億美元的外匯交易',
    sqqswergtbesf: '我們提供可在電腦或行動裝置下載安裝的交易平台，無論您身在何處，都能下載平台進行交易',
    ssertbesf: '全球市場盡在指尖',
    sqqqsertbesf: '外匯市場、大宗商品、指數、股票、債券、加密貨幣差價合約',
    mmktbesf: '強大的交易終端',
    mmkrttbesf: 'Windows電腦系統、網頁瀏覽器、iOS/Android行動系統、Mac電腦系統',
    sefbesf: '資金運用，由你掌控',
    sefbesersf: '即時入金',
    sefqwwersf: '快速出金',
    seqwwdbrsf: '多種管道可供選擇',
    sefggrsf: '隨時隨地使用AEGIS行動應用程式交易',
    sefgdgdf: '專業交易系統',
    sertwqc: '輕鬆監控行情',
    sesertwqc: '多元支付方式',
    serrtsbwqc: '全天候24小時線上客戶支援',
    ermlsbwqc: '開戶四步驟',
    mlsbwqc: '選擇帳戶類型，填寫簡單安全的申請表',
    sqwwmlsbwqc: '身分驗證',
    nhywqc: '透過引導系統快速完成驗證',
    miyyc: '帳戶儲值',
    mibhyyc: '使用多種入金方式為您的交易帳戶儲值',
    mkplyc: '在您的真實交易帳戶開始交易全球市場',
    mqwrplyc: '交易規則',
    mqwrdbplyc: '點差與手續費',
    lpoobplyc: '交易時間',
    lpoosnbplyc: '入金儲值',
    yuyutyc: '出金提款',
    tyyuyutyc: 'why AEGIS?',
    yyufttyutyc: 'why AEGIS',
    rrttyutyc: '我們的使命',
    miktyc1: '我們提供頂尖的交易解決方案，為各種規模的客戶提供專業級工具、業界領先的報價與世界一流的服務。 ',
    miktyc2: '我們為各類投資人提供卓越的執行技術、更低的點差與無與倫比的流動性。 ',
    miktyc3: '我們致力於持續創新、不斷優化，並運用最新的前沿技術。 ',
    miktyc4: ' 透過開放式銀行解決方案，我們支援超過120家銀行、經紀商以及300多家金融中介機構，提供多資產執行、主經紀服務與交易技術。',
    rrttyusmteryc: 'AEGIS 的使命，是為零售客戶與機構交易者提供同等、最專業且高度透明的交易環境，讓交易者能更專注於交易本身；同時致力為交易者提供優異的點差、訂單執行與專屬服務。',
    rpoeryc: '我們的價值觀',
    mkfsoeryc: '誠信',
    lpoeryc: '公平公正',
    lpoerycmh: '透明公開',
    lbgtpoerycmh: '負責盡責',
    kiiooerycmh: '持續創新',
    qeecmh: '值得信賴',
    wrttmh: '完善的公司管理制度',
    wrtbgttmh: '合規管理',
    wrmutbgttmh: '平臺資質：MSB牌照為31000330384694',
    wrqetbgttmh: '瞭解我們的執照資訊 ',
    tyttmh: '選擇我們，代表您在受到嚴格監管的平台進行交易，確保交易的公平性。 ',
    tymplttmh: '嚴格稽核 ',
    tymplttmpph: 'AEGIS設有獨立外部稽核機制，監督營運流程並確保完全遵循法規。 ',
    lplttmpph1: '機密保護 ',
    lplttmpph2: 'AEGIS實施嚴格資訊管控，遵循「必要知悉」原則，管理公司內部及外部機密、敏感',
    lplttmpph3: '客戶資料。除非客戶要求或法律規定，AEGIS不會主動揭露客戶資訊。 ',
    tyyyph3: '為何選擇AEGIS ',
    tyyyptyyu: '秉持滿足交易者真實需求的理念，AEGIS已成為全球最大的差價合約交易商之一 ',
    ttghtyyu: '超低點差 ',
    ttghtweryyu: '快速執行 ',
    tadtsweru: '彈性交易手數 ',
    tpmksweru: '頂級客戶服務 ',
    mmmmksweru: '優異的交易平台 ',
    mbhyksweru: '信賴與透明 ',
    mbhyksdsweru: '信賴與透明是AEGIS的核心價值。AEGIS承諾絕不人為干預報價、竄改價格或設定交易限制。 ',
    mmmmksweru2: '我們透過全球領先的AEGIS交易系統，為客戶提供交易支援。 ',
    tpmksweru2: 'AEGIS致力提供無可比擬的客戶服務與支援，團隊成員皆具備豐富的外匯產業資歷，深入瞭解交易者的需求。選擇AEGIS，您可安心交易，我們全年無休、24小時陪伴著您。 ',
    tadtsweru2: '客戶可透過本平台交易環境下單，交易規模介於 0.01 手（1,000 基礎貨幣）至 100 手（1,000 萬基礎資產）之間。我方技術會分類並排序各項報價，支援於多家報價供應商及其報價層實時執行訂單，確保不論任何交易規模皆能取得最優報價。 ',
    ttsweru: '頂尖技術 ',
    ttswrheru: 'AEGIS與全球頂尖交易技術商合作，打造優質交易環境與進階交易工具，包含：市場深度（DOM）、內部點差監控、階梯交易、自訂模板自動平倉等。我們的iOS與Android行動交易應用皆已最佳化，帶來絕佳的行動交易體驗。 ',
    qscrgfg: 'AEGIS於全球各地資料中心佈建企業級硬體設備，流動性提供商亦將伺服器設置於此。專屬光纖網路連線，為客戶實現最低延遲、最快的訂單執行速度。 ',
    ewftyyu: '我們的目標是在各種市場環境下，為交易者爭取最低的點差。我們投入龐大資金建置技術，並與全球規模最大、信譽最佳的流動性提供商建立合作。持續擴增流動性來源，讓交易者享有全球頂級的外匯交易條件，打造優質交易環境。 ',
    ewfbgttyyu: '您可查閱完整知識庫尋求解答，亦可直接聯繫我們24小時線上客服 ',
    enyuqyyu: 'AEGIS的監管單位 ',
    enmrryuqyyu: 'AEGIS 持有 MSB 牌照，牌照號碼：31000330384694',
    eswnmrryuqyyu: '我的資金存放於何處？ ',
    mkjryuqyyu: 'AEGIS將客戶資金獨立存放於一級銀行的專屬隔離帳戶。 ',
    mkjbtqu: '若資金保管銀行發生危機，我的資金會如何處理？ ',
    mkjsdbtqu: 'AEGIS將客戶資金分散存放於多家頂級國際銀行的隔離帳戶，降低單一銀行的交易對手風險。 ',
    mkjmkuisdbtqu: 'AEGIS如何使用我的個人資料？ ',
    nmurdqu: '我們可能會蒐集您的個人資料，用於身分驗證、履行法規義務以及防範詐騙。我們絕不會將您的個人資料販售給第三方作為行銷使用。隱私權政策會詳細說明個人資料的處理方式。 ',
    nmursdsfsdqu: '我的個人資料與證件是否安全？ ',
    nmursdsfssfbgdqu: '如果我的帳戶遭到駭客入侵，該怎麼辦？ ',
    nmurffffbgdqu: '關於交易帳戶 ',
    nmurfertbgdqu: '開立真實交易帳戶的最低入金金額為何？ ',
    nqertbgdqu: 'AEGIS提供的槓桿倍數範圍？ ',
    nqertbgccdqu: 'AEGIS的交易時間？ ',
    nvrrdqu: '交易全球熱門大宗商品，包含能源、農產品與金屬。AEGIS結合優質報價與彈性交易環境，提供頂級交易產品。 ',
    nvrrdsvqu: '透過AEGIS專業交易平台，您可以簡單、彈性地參與全球熱門大宗商品交易，包含能源與金屬。 ',
    mkwqqu: '大宗商品市場深受供需變化影響，相當吸引投機交易者。 ',
    mkwqbtqu: '能源 ',
    mkwwerrqu: '您可在我們的專業平台交易美元計價的現貨能源合約，包含原油、布蘭特原油與天然氣。現貨能源商品，適合僅進行價格投機的投資人，具備諸多優勢。 ',
    mkwwweru: '貴金屬',
    mkwqertu: 'AEGIS提供高倍槓桿，可交易黃金、白銀等貴金屬兌美元的現貨價格，亦可交易鉑金、鈀金兌美元貨幣對。',
    wmklertu: '軟性大宗商品',
    wmmkiotu: '除了能源與金屬合約，AEGIS亦提供玉米、大豆、砂糖、咖啡、小麥等軟性大宗商品差價合約，全部商品皆享有低點差，槓桿最高可達1:100。',
    yumlu: '如何進行大宗商品交易?',
    yuwrmlu1: '大宗商品包含能源、農產品與金屬，主要於期貨市場交易，價格由供需關係決定。 ',
    yuwrmlu2: '供給端影響因素：農產品受天氣影響，礦產與能源則取決於開採成本。 ',
    yuwrmlu3: '商品需求通常與經濟週期、人口成長等總體環境息息相關。大宗商品可單獨交易，亦可搭配成組合交易。 ',
    yuwrmlu4: '金屬與能源多與主流貨幣配對交易，農產品期貨則以獨立合約形式交易。',
    yypbg4: '點差表',
    yypbgse4: 'AEGIS精選多元產品，協助您進入全球最熱門、流動性最佳的市場，把握全天候24小時交易機會。',
    yypwe4: '外匯市場為全球流動性最高的金融市場，每週5天、全天24小時開放交易。交易者可在61種貨幣對中享有超低點差、優異執行品質與充足的銀行間流動性。',
    yypeete: '涵蓋所有美元貨幣對與多數非美元貨幣對 ',
    yypempete: '有效避險匯率波動與地緣政治風險 ',
    yypwbge4: '全球最大交易市場，每日交易量突破5兆美元 ',
    yypwbgyur4: '豐富的日內交易機會 ',
    yypsqbgyur4: '透過AEGIS全球指數差價合約，參與全球主要股市。指數點差最低0.5點，零手續費，且跨市場每週5天、全天24小時交易，協助交易者全面掌握股市走勢。 ',
    dgdgsg1: '涵蓋全球主要國家及地區股市指數  ',
    dgdgsg2: '股市指數反映對應交易所大盤整體表現',
    dgdgsg3: '指數合約可有效避險股票交易風險  ',
    dgdgsg4: '以小額資金操作大額交易部位',
    dgdqegsg4: '交易能源、農產品、貴金屬商品，如同交易美元計價貨幣對或期貨差價合約。我們結合優質報價與每0.1手彈性下單機制，提供頂級交易體驗。',
    dgdtyyg1: '涵蓋黃金、白銀、原油等主要熱門交易品項。',
    dgdtyyg2: '商品具備高流動性與高波動特性',
    dgdtyyg3: '相對較低的保證金門檻',
    dgdtyyg4: '提供專業市場觀點與線上教學資源',
    dgdtyyseg4: '加密貨幣',
    dgdtyysegse4: '您可交易全球主流熱門加密貨幣，做多或做空皆可，全年無休、每週7天交易。價格走勢主要受市場情緒、新聞消息與投資人恐懼及貪婪心理影響。透過受英國金融服務管理局（FSA）監管的差價合約提供商交易，最高可享1:200槓桿，同時避開加密貨幣交易所的相關風險。',
    dgdtyyswm1: '標的資產包含大宗商品、外匯、指數、股票等',
    dgdtyyswm2: '選擇權，是取得合約期間內標的資產槓桿獲利的權利',
    dgdtyyswm3: '鎖定風險的交易工具',
    dgdtyyswm4: '有效避險其他標的交易產生的風險',
    drryswm4: 'AEGIS產品具備全球頂級競爭力。從AEGIS出發，進入全球規模最大、流動性最佳的金融市場。',
    drryrgrr: '外匯市場每週5天、全天24小時開放，為全球規模最大、流動性最強的市場，每日交易量突破4兆美元，遠超所有實體交易所市場。',
    erqgrr: '外匯交易為貨幣對交易，預測一種貨幣相對於另一種貨幣的漲跌。貨幣皆以配對形式交易，例如歐元兌美元（歐元/美元）。',
    erqgrsder: '外匯交易點差',
    eerrsder: 'AEGIS提供業界極低的外匯點差，歐元/美元平均點差僅0.1點。超低點差搭配低延遲企業級硬體，是日內交易者與自動交易程式（EA）使用者的最佳選擇。下表列出所有主要貨幣對的最小點差與平均點差。',
    eeqwrtsder: '如何進行外匯交易？',
    eeqwrppqer1: '外匯交易概念類似股票或期貨交易，差別在於外匯是買入或賣出一種貨幣兌換另一種貨幣，無須實際提領貨幣。',
    eeqwrppqer2: '相較其他金融商品，外匯交易的手數彈性極高，最小僅需1000單位（微型合約）。',
    eeqwrppqer3: '外匯交易普遍使用槓桿，最高可達1:100，這與不提供槓桿的股票交易截然不同。',
    egtqer3: '合約名稱',
    ewerqer3: '一筆訂單即可交易一籃子標的所組成的指數。在AEGIS交易平台，交易全球熱門指數。',
    ewertt4: '股指是差價合約中最熱門的品項之一。AEGIS提供全球各國股指，包含英國富時100指數、美國標準普爾500指數、美國道瓊工業指數、日本日經225指數等。',
    empewertt41: '股市指數是觀察市場表現的重要指標，富時100、道瓊指數等追蹤交易所藍籌股整體走勢，也是判斷市場情緒的有效工具。指數成分股的價格變動，都會反映在指數整體走勢上。',
    empewertt42: '交易股指差價合約，可一次觀察一籃子股票的整體表現，不用個別追蹤單一個股。AEGIS於專業交易平台提供線上股指差價合約交易服務。',
    empesaifw: '如何判定客戶是否享有澳洲200指數（AUS200）股息調整資格?',
    empesaifwwr1: '舉例說明：假設澳洲200指數除息日為2022年8月18日。客戶必須在8月18日前建立澳洲200指數部位，並持有至當日，才能享有每手2.44美元的股息調整。股息入帳或扣款取決於客戶做多或做空：做多每手可獲得2.44美元，做空則每手扣除2.44美元。金額會在扣款/入帳前，轉換為客戶帳戶的計價貨幣。 ',
    empesaifwwr2: '澳洲200指數每手股息調整為2.44澳幣，美國500指數則為每手2.44美元。我們會發布除息試算表，預告當週指數預計調整點數，各指數實際除息金額亦會定期於公告更新。',
    lpiwr2: '加密貨幣波動性高、去中心化且多數未受監管，交易族群以散戶投機者為主。選擇受英國金融服務管理局（FSA）監管的交易商，交易全球新穎且熱門的差價合約商品。',
    lpiwswr2: '不同於外匯、股票、大宗商品等市場，加密貨幣市場由散戶投機者主導。交易加密貨幣，不會有中央銀行干預、銀行交易商操控訂單流向，或是大型退休基金影響價格的狀況。',
    lqerwswr1: '比特幣、以太幣等加密貨幣價格，主要受新聞消息與市場情緒（散戶的恐懼與貪婪）影響。這些因素變動容易造成劇烈日內波動，適合風格激進、經驗豐富的日內交易者。',
    lqerwswr2: 'AEGIS加密貨幣差價合約，讓您無須實際持有加密貨幣，即可做多或做空。不用承擔貨幣存放的安全風險與交易對手風險，就能參與價格走勢，概念類似交易原油期貨、而非持有實體原油。',
    lqftthjj: '比特幣差價合約',
    lqfttsehjj: '比特幣是全球第一款、也是規模最大的加密貨幣，市值超過1000億美元，也帶動數百種同類加密貨幣問世。',
    lqfttseqwhjj: '以太幣差價合約',
    lqfttqehjj: '以太幣為全球第二大加密貨幣，被譽為「下一個比特幣」，獲得微軟、摩根大通、英特爾等大型國際企業認可與支持。',
    lqfttophjj: '達世幣差價合約',
    lqfttnuuj: '達世幣主打即時交易與使用者隱私，交易速度優於多數同類加密貨幣，具備更高的流動性。',
    lyuitnuuj: '萊特幣差價合約',
    lyuitnuuswqj: '萊特幣由前Google工程師研發，改良比特幣技術，具備更快處理速度與更大發行量，也是首個導入隔離見證（SegWit）技術的加密貨幣，在不更動區塊鏈底層架構的前提下加快交易速度。',
    lgyunuuswqj: '比特幣現金差價合約',
    lbhhswqj: '比特幣現金由比特幣區塊鏈硬分叉而來，無需使用隔離見證技術，並將區塊大小從1MB提升至8MB。',
    lbhhrtyy: '瑞波幣差價合約',
    lbhhrtysfbgy: '瑞波幣同時具備交易網路與加密貨幣屬性，2012年正式推出，主打銀行跨國轉帳應用，近期成長迅速。',
    lbhhrtysssfbgy: '如何交易加密貨幣差價合約？',
    lbhqergy1: '比特幣等加密貨幣的價值，由該類資產專屬的供需關係決定。',
    lbhqergy2: '比特幣等加密貨幣總發行量有限，需求提升將帶動價格上漲。 ',
    lbhqergy3: '需求來自投機交易與實際應用，例如使用比特幣進行線上消費支付。',
    lbhqergy4: '加密貨幣價格也會跟隨股票、外匯等傳統市場情緒波動，在市場負面情緒擴散時，反應更為劇烈。',
    lbqergbgy4: '外匯市場是全球最大金融市場，每週5天、全天24小時開放，隨時都能進行交易。',
    lbqsseg: '外匯保證金交易是買賣雙方的合約，約定在部位開倉與平倉時，結算兩種貨幣的價差。',
    lbqdqwe: '外匯最大優勢為全天候交易，搭配槓桿機制，每週從周日晚間至周五晚間皆可進場，依據國際資金流向與新聞事件進行投機。外匯市場規模龐大、流動性充足，是公平交易、真實反映價格的交易平台。',
    lbqdsewrqwe: '全天候交易市場',
    kpoodrewrqwe: '外匯市場每週5天、全天24小時運作，隨全球各大金融中心開盤接續交易。紐西蘭市場周日晚間開盤，紐約市場周五收盤後結束交易。不同時區市場重疊時，整體流動性最佳。',
    kprttewrqwe: '公開透明',
    kpsrrewrqwe: '部分實體交易所市場，常見大型投資人操控股票或大宗商品價格以謀取不當利益。但外匯市場流動性極高，難以被人為干預，提供所有參與者公平透明的交易環境。',
    kpsrbnue: '漲跌市場皆可交易',
    kpsvrnue: '外匯交易無方向限制，可同時做多、做空。看漲貨幣對就買進（做多），看跌則賣出（做空）。',
    kpsvrfffnue: '入門門檻低',
    kpsvrfffsfnue: '相較其他金融市場，外匯交易所需資金更低。同時可透過電腦、行動裝置隨時連線進場交易。',
    kpssfffnue: '槓桿交易',
    kpsnmfue: '外匯支援槓桿交易，僅需小額資金就能操作大額部位。舉例來說：帳戶內有1000美元，使用1:100槓桿，即可建立價值100,000美元的部位，為本金的100倍。須特別留意：槓桿雖能放大獲利，也會同步放大虧損。',
    kpqqsnmfue: '市場波動性',
    kvfdmfue: '外匯市場每日交易量龐大，價格持續波動，創造眾多交易機會。您可依交易風格挑選合適貨幣對：澳幣/紐幣日內震盪小、點差低，適合新手；歐元/美元震盪幅度大、走勢變動快，適合進階交易者。',
    kvfdmsdffue: '高流動性',
    mplhhhfue: '交易成本低',
    mpaaahfue: '外匯單筆交易成本，不到一般股票交易的十分之一，大幅節省交易支出，也讓小額資金就能入場交易。',
    mpldffue: '劣勢',
    mwrrffue: 'AEGIS針對指數、能源、金屬、大宗商品等各類差價合約，提供彈性交易條件。',
    mmmbrtffue: '差價合約（CFD）是熱門且持續成長的短期投資商品，可有效活用資金、分散投資組合或進行避險。以下為交易差價合約的優勢。',
    nhhebrtffue: '漲跌行情皆可投機',
    mpldsbrtffue: '彈性合約規模',
    aaartffue: '差價合約（CFD）是買賣雙方簽訂的合約，約定在合約開立與平倉時，結算有價證券、票券或其他資產的價差。',
    mpldsbsfffue: '外匯市場屬於場外交易市場，與股票及期貨市場有所不同。這代表外匯交易者在持倉規模上具備高度彈性，可在 0.01 標準手（1 超迷你手）至 100 手之間自由選擇任意交易數量，讓交易者能更靈活地控管風險。',
    mpldffusffe: '在使用槓桿交易產品之前，您應該首先考慮您的風險偏好和投資策略。使用槓桿有利有弊，既能擴大利潤，也會加劇虧損。如果市場出現不利於您的巨幅波動，你的帳戶可能會出現穿倉。這裡需要強調的是您並不實際擁有差價合約下的標的產品。可以在我們網站找到關於CFD交易的收益和風險的詳解。',
    kvfdmsfsdffue: '高流動性是外匯市場的核心優勢之一，每日交易量突破5兆美元。資金可快速轉換為現金且不影響報價，大額資金進出也難以改變市場價格。',
    bfdgdg1: '差價合約為標的資產衍生商品，您無需持有實體標的，就能隨價格漲跌獲利，漲跌市場皆可操作。',
    bfdgdg2: '看漲市場時，買入差價合約後再賣出平倉，稱為「做多」。',
    bfdgdg3: '看跌市場時，先賣出差價合約部位，日後再買回平倉，稱為「做空」。',
    mioisdr3: '避險其他投資部位',
    bfdgdgsdr3: '靈活運用資金',
    bfdgdgsdrqqq3: '差價合約為槓桿商品，僅需繳納小額保證金，就能參與標的資產交易。開倉所需保證金會隨差價合約價格變動。行情順勢時，槓桿放大獲利；行情反向時，也會同步擴大虧損。',
    fgdgsdgs1: '差價合約可做多、做空的特性，是避險投資組合的絕佳工具，也是低成本鎖定獲利、防範價格反向風險的方式。',
    fgdgsdgs2: '舉例來說：若您持有長線投資組合，但預期短期有風險，便可利用差價合約進行避險。當投資組合資產價格下跌，差價合約的獲利就能抵銷虧損。',
    fgdgsdfsdgs2: '商務合作',
    fgdgsdfsfsdgs2: '成為全球頂級交易平台合作夥伴，為您的事業注入強大動能',
    fgdgsdfsfss: '為何選擇與AEGIS合作？',
    bfthfh1: '每成功推薦一位客戶，即可獲得高達600美元獎勵，這只是眾多合作優勢之一。',
    bfthfh2: 'AEGIS受完整監管，享全球認可。',
    bfthfh3: '我們是擁有超過20年產業經歷的頂級經紀商。',
    bfthfh4: '我們的交易平台榮獲多項業界大獎。',
    bfthfh5: '我們提供優渥的分潤方案。',
    bfthrwedqed: '誠摯邀請您加入',
    bfthfh6: '您將配屬專屬合作經理人。',
    bfthsqefh6: '遞交申請文件',
    bftsrrfh6: '申請類型',
    serrvqq: '姓名',
    serrvqsffq: '請選擇',
    serrvqsseffq: '請填寫',
    serrvqsssqeeffq: '聯絡人',
    serbgeffq: '聯絡電話',
    seqebgfq: '聯絡信箱',
    seqebgsdffq: '相關文件',
    sesqesdffq: '點擊上傳營業執照',
    sesqesdfswgafq: '登入帳號',
    seswbghfq: '請填寫手機號碼/電子信箱',
    seswbghfqse: '說明：您須具備AEGIS平台個人帳號，若尚未註冊，請先完成註冊',
    seswbghfqssqee: '邀請碼',
    sesqwwqee: '送出',
    seswbgsshfqssqee: '說明：請向您的推薦人索取邀請碼',
    qrvbshfqssqee: '上傳身分證件',
    sdaqssqee: '上傳身分證正面',
    sdwwerree: '身分證反面',
    sdwwsqeee: '上傳護照',
    sdqenhe: '上傳駕駛執照',
    sdqesdvednhe: '公司名稱',
    sdqeswer: '回到今日',
    swvbr: '即時掌握全球金融動態',
    swsswevbr: '返回',
    swsswevsqbr: '來源',
    swrgsqbr: '財經快訊',
    swsdrgsqbr: 'AEGIS最新動態',
    swsdsdrr: '我們極度重視客戶隱私，並制定完善政策與作業流程，保護向您蒐集的各項資料。',
    saswsdsdrr: 'AEGIS開戶最低入金為200美元或等值貨幣。',
    cqdfffgsg: 'AEGIS提供最高1:100的槓桿倍數。',
    swsdsdrsar: '建議您立即變更交易帳戶與註冊信箱密碼，切勿拖延。所有安全資訊務必保密，不要儲存於共用或公用裝置。請聯繫我們的客服團隊通報狀況，我們會儘速處理。',
    swssvgdsdrsar: '不同交易商品的交易時間各有差異，詳細時程請參閱商品規格說明。',
    swssdenbng: 'AEGIS合約轉倉時間為何？',
    swssdbng: 'AEGIS合約於格林威治標準時間（GMT）0點進行轉倉。',
    swssdbsvng: 'AEGIS提供哪些交易商品？',
    swssqdsbsvng: 'AEGIS提供外匯、大宗商品、指數、加密貨幣等多元交易商品。',
    swsswwg: '如何將資金入金至帳戶？',
    swsqweerwg: 'AEGIS提供多種入金管道，包含銀行電匯、金融卡、區塊鏈轉帳等，詳細說明請參閱入金專頁。',
    swsqbreweerwg: '入金後多久會入帳？',
    swssaqwfwg: '金融卡、區塊鏈等線上入金即時到帳；國內銀行電匯約1至2個工作天，國際轉帳最長約3至5個工作天。',
    sbgrewfwg: '如何辦理出金提款？',
    sbgrebrwfwg: '請登入會員中心提交出金申請。',
    stgsbrwfwg: '如何開立AEGIS真實交易帳戶？',
    stgsbtewfwg: '依據塞席爾金融服務管理局 2020 年《反洗錢法》規定，AEGIS 於為您開立交易帳戶前，須先行完成您的身份驗證作業。您需提供附有照片之身分證明文件與地址證明，以供我方核實身分。',
    stgsbtsqfwg: '將資金存入真實交易帳戶，是否可賺取利息？',
    stgsbtssdfqfwg: 'AEGIS不針對帳戶餘額計付利息。',
    stgsbtqassdfqfwg: '長期不交易，是否會收取帳戶管理費或閒置費？',
    stgsbwmjwg: 'AEGIS不收取任何帳戶管理費與閒置費。',
    stgsbppjwg: 'AEGIS是否為純正電子交易網路（ECN）經紀商？',
    stgsadbppjwg: '當您透過我方進行交易，所有成交價格皆取自流動性供應商提供之 ECN 報價。AEGIS 並未設立內部交易盤房自主定價，我們絕不會以任何形式篡改報價，因此平台價格屬於「純正 ECN 價格」。',
    sttttqwg: 'AEGIS是否會對客戶部位進行避險對衝？',
    sttsehttqwg: '是的，我們可能會針對部分或全部客戶部位進行對衝，以控管整體營運風險。',
    dsfsfgse: '香港貴金屬牌照為：A-B-26-05-10926',
    dsfssweefgse: '本人已閱讀並同意',
    dqessweefgse: '經紀商協議',

    dqqqwgse1: '1. 前往AEGIS官方網站點擊Google Play下載，或於Google Play搜尋「AEGIS」。',
    dqqqwgse2: '2. 點擊「安裝」即可。',
    dqqqwgse3: '3. 安裝完成後點擊開啟，即可進入APP，展開您的交易旅程。',
    dmiooefgse: '下載指南',
    dqqwegse: 'Windows版',
    dqvfereegse1: '1. 前往AEGIS官方網站，或在APP首頁點擊下載，檢視Android版下載QR Code。',
    dqvfereegse2: '2. 開啟手機瀏覽器，透過「掃描QR Code」功能掃描條碼，開始下載BPMarkets.apk檔案。',
    dqvfereegse3: '3. 下載完畢後進入安裝畫面，部分手機系統會提示該軟體未經應用商店檢測、存有風險，請點擊同意並繼續安裝。',
    dqvfereegse4: '4. 安裝完成後返回手機桌面，點擊圖示進入APP，展開您的交易旅程。',
    dqqwessdgse: 'iOS版',
    qwdfdfdsf: 'Android版',
    dqbgrre: '第一步',
    dqbgrsdfre: '第二步',
    dqbgqqqre1: '1. 前往AEGIS官方網站，或在APP首頁點擊「下載」，檢視iOS版下載QR Code。 ',
    dqbgqqqre2: '2. 彈窗跳出「在iTunes中開啟此頁」時，選擇「開啟」→「安裝」。',
    dqbgqqqre3: '3. 返回手機桌面，進入iOS系統設定→一般→VPN與裝置管理，信任「MIGROS TICARET A.S.」企業級APP，接著重新開機。',
    dqbgqqqre4: '4. 重開機完成後，於桌面找到「BPMarkets」，點擊進入APP展開您的交易旅程。',
    dqbgrsdsdfre: '第三步',
    sfnmhdfre: '*請留意您的手機系統是否支援Google Play服務；若支援，可登入Google帳號下載；若系統不支援，請選擇本地下載',
    dqmjjqdsdfre: '方法二：企業簽章下載',
    dqmjjsssqdsdfre: '方法二：本地下載',
    dqsvmjjqdsdfre: '方法一：Google Play下載',
    dqbgrssqqdsdfre: '第四步',
    dqssddgse: '1. 僅持有中國大陸Apple ID',
    dqssddgsesvfd: '持有海外Apple ID',
    dqssdsdffd: '若持有海外Apple ID，請先登入，再點擊下載連結，或至商店自行搜尋AEGIS下載。',
    dqsassddgse: '很抱歉，AEGIS目前尚未於中國大陸地區App Store上架，請使用海外Apple ID下載；您可註冊海外Apple ID後再進行下載',
    advbsdgse: '方法一：App Store下載。',
    aedqqwegse: '前往AEGIS官網：https://www.bp-markets.com，點擊「交易」、「登入」、「註冊」任一按鈕，皆可跳轉至網頁版交易系統，開始交易。',
    wrrefgse: 'AEGIS支援Android、iOS、Windows系統，各系統操作方式請參閱下方教學。提醒您：Windows建議使用Chrome瀏覽器；iOS若透過App Store下載，需備有海外Apple ID。',
    wrradfefgse: '入金即享高額贈金，交易達標即可提現',
    wrraqwfgse: '邀請好友，享高額交易返佣',


    wrreefg: '美股',
    wrresvtefg: '我們的團隊憑藉豐富的智識資本與深厚專業領域知識，協助您達成投資目標。',
    wrreqsvefg: '我們秉持不受拘束的客戶導向服務方針，提供客製化完整規劃，以多元彈性的建議提升客戶投資價值。',
    wrreefsbgg: '客戶十分認可我們協助其釐清、追尋財務目標的專業能力，我們也以提供高品質服務為榮。',
    mlpwrreefg: 'Aegis 始終堅持創辦初心，在提供媲美大型金融機構的投資與財富管理商品、服務之餘，也維持眾所熟知的專屬個人化服務體驗。',
    mkpwrreefg: '透過與加拿大皇家銀行旗下清算託管單位 RBC Clearing & Custody（RBC C&C）建立核心清算合作夥伴關係，Aegis 得以提供頂尖服務。RBC C&C 母公司加拿大皇家銀行（NYSE: RY）是全球頂尖多元金融服務集團之一。客戶的資產由第三方獨立託管，這份資產保障帶來的安心感，正是我們服務的核心價值。我們具備業界領先級別問題處理實戰經驗；不論客戶需求為財富管理、退休規劃、保險、投資銀行、私人銀行或是機構服務，Aegis 皆配置對應專業團隊提供支援。我們引以為傲的是，能為各類型客戶提供專屬、用心的專業服務。',
    svbywrreefg: 'Aegis 的成立初衷，是為了滿足特定客群的需求。隨著客戶需求持續擴張，我們的商品線也同步拓展。如今 Aegis 已成為全美據點遍佈的頂尖全方位投資公司。',
    nuiwrreefg: 'AEGIS 以投資銀行業務為核心，包含IPO承銷、私募融資、PIPE交易、企業併購顧問等服務，同時搭配機構與高資產客戶的證券經紀、交易執行業務，連結中小企業融資需求與機構投資人資金配置，是美國多層次券商體系內活躍的資本市場參與者。',
    bgwrreefg: 'AEGIS 於美國登記註冊，為FINRA註冊證券經紀交易商（Broker-Dealer,CRD:15007），同時受美國證券交易委員會SEC監管，亦為SIPC會員機構。',
    wrreefsqg: '布局美股，等同掌握全球經濟成長動能',
    wrredwwsdsdefg: '美國建置以美國證券交易委員會（SEC）為核心的嚴格監理體系，《證券法》《證券交易法》等完備法令，為投資人提供完善保障。',
    wadbwsdefg: '高度透明的市場環境',
    wrredwwsdefg: '成熟完備的監理制度',
    wrredwwsvbfsdefg: '美股被視為全球透明度最高的市場之一，上市企業須遵循嚴格資訊揭露規範，確保所有投資人能公平、即時取得相關資訊。',
    wrredwwefg: '全球規模最大股票交易市場',
    assfbd: '布局全球資產，掌握產業商機',
    sbgassfbd: '美股是透明且高效率、高流動性的金融市場；截至2022年7月，全球股市總市值達108兆美元，美股占比40.9%，約44兆美元。身為全球最大股票市場，龐大成交量與總市值，為全球投資人帶來獨特投資機會。',
    assvrtsfbd: '美股，全球資本市場核心',
    aerassfbd: '美股匯集全球頂尖企業，包含輝達、谷歌、蘋果、亞馬遜、特斯拉，也是IPO與獨角獸企業首選上市地。紐約證交所、納斯達克等活絡交易平台提供多元投資標的；同時具高度國際化特色，標普500成分企業約40%營收皆來自海外市場。',
    wrredwwefsg: '涵蓋納斯達克、紐約證交所等大型交易所全部上市有價證券',
    wrredswqsg: '完整覆蓋盤前、盤中、盤後全部交易時段',
    qbjjwqsg: '投資全球龍頭企業',
    qbsvvjjwbgqsg: '成熟投資人結構',
    qbjjwbgqsg: '新股發行',
    qbjqqqgqsg: '手續費低廉，節省成本，最大化IPO獲利',
    qbjqyyqsg: '申購截止時間更晚，資金運用效率更佳',
    qbjqyplsg: '搶先參與新股，亦可提前賣出，領先市場交易',
    qbjqyqbgtplsg: '全球規模最大股票交易市場',
    qbjqntwwtplsg: '涵蓋納斯達克、紐約證交所等大型交易所全部上市有價證券',
    qbswtplsg: '完整覆蓋盤前、盤中、盤後全部交易時段',
    qbssswtplsg: '美股以機構投資人為交易主力，持有市值占比近八成，市場定價更具理性，重視長期價值投資。',
    qbswtpmmlsdsg: '布局全球產業龍頭，共享科技與消費革新紅利',
    qbvtymmlsdsg: '盤前交易：夏令時對應馬來西亞時間16:00至21:30；冬令時對應馬來西亞時間17:00至22:30。',
    mmkkpmmlsdsg: '盤後交易：夏令時對應馬來西亞時間04:00至08:00；冬令時對應馬來西亞時間05:00至09:00。',
    qbswtpmmlssbgdsg: '夏令時（每年3月第二個周日至11月第一個周日）：對應馬來西亞時間21:30至隔日04:00。',
    qbswddbsg: '常規交易時段：美國東部時間周一至周五09:30至16:00，中午不休息。亞洲投資人對照時間：',
    qbswddbsvfsg: '冬令時（每年11月第一個周日至次年3月第二個周日）：對應馬來西亞時間22:30至隔日05:00。',
    qbjqypbqkilsg: '直接參與蘋果、微軟、輝達等全球龍頭企業成長，共享科技與消費革新紅利；依托全球最完善、最嚴謹的金融監理體系，守護您的資產安全。'    

}


// WEBPACK FOOTER //
// ./src/common/lang/zhf.js